//import * as d3 from 'd3';

// Data sets.
const Data = ( props ) => {
};

// Generates random normal data.
//Data.randomNormal = [];
//let f1 = d3.randomNormal(  0.15, 0.2 ),
//    f2 = d3.randomNormal( -0.15, 0.2 );
//for( let i = 0; ( i < 500 ); i++ ) {
//    let value = ( i % 2 ) ? f1() : f2();
//    Data.randomNormal.push([ Math.round( value * 100 ) / 100 ]);
//}
//console.log( Data.randomNormal );

// Returns column names.
Data.getColumnNames = (  dataSet ) => {
    let names = [];
    switch( dataSet ) {
        case "Normal": names = [ "Random Normal, Bimodal" ]; break;
        case "Penguins": names = [ "Species", "Island", "Bill Length (mm)", "Bill Depth (mm)", "Flipper Length (mm)", "Body Mass (g)", "Sex" ]; break;
        case "Sales": names = [ "Model", "Cars Sold, 2022 Q1" ]; break;
        case "Stocks": names = [ "Year", "S&P 500 Index" ]; break;
        case "Trends": names = [ "Week Number", "Week", "Google Trends 2020", "Interest" ]; break;
        default: names = [ "Species", "Sepal Length (cm)", "Sepal Width (cm)", "Petal Length (cm)", "Petal Width (cm)" ]; break;
    }
    return names;
};

// Returns values.
Data.getValues = (  dataSet ) => {
    let data = [];
    switch( dataSet ) {
        
        // Random normal, bimodal.
        case "Normal": data = [
            [-0.08],
            [-0.02],
            [-0.35],
            [0.21],
            [-0.6],
            [0],
            [-0.46],
            [0.25],
            [-0.3],
            [0.2],
            [-0.54],
            [-0.07],
            [-0.03],
            [0.14],
            [-0.34],
            [0.21],
            [0.02],
            [-0.27],
            [0.02],
            [0.16],
            [-0.02],
            [0.11],
            [-0.12],
            [0.59],
            [-0.22],
            [0.06],
            [0.03],
            [-0.16],
            [-0.22],
            [0.03],
            [0.08],
            [0.24],
            [0.01],
            [0.04],
            [0.46],
            [0.06],
            [-0.15],
            [0.31],
            [0.14],
            [0.25],
            [-0.27],
            [0.6],
            [-0.21],
            [0.29],
            [-0.31],
            [0.22],
            [0.16],
            [0.09],
            [-0.07],
            [0.05],
            [-0.3],
            [0.19],
            [-0.44],
            [-0.25],
            [-0.41],
            [0.16],
            [-0.4],
            [0.08],
            [-0.26],
            [0.17],
            [-0.49],
            [0.35],
            [-0.21],
            [-0.31],
            [-0.12],
            [0.09],
            [-0.21],
            [0.12],
            [-0.39],
            [0.21],
            [-0.59],
            [0.2],
            [-0.01],
            [0.38],
            [0.2],
            [0.27],
            [-0.16],
            [-0.06],
            [0.08],
            [0.17],
            [-0.33],
            [0.33],
            [-0.09],
            [-0.04],
            [-0.04],
            [0.08],
            [-0.06],
            [0.25],
            [0.14],
            [-0.01],
            [-0.01],
            [-0.33],
            [-0.23],
            [-0.26],
            [-0.32],
            [-0.03],
            [-0.2],
            [0.12],
            [0.1],
            [0.01],
            [-0.18],
            [0],
            [-0],
            [0.35],
            [-0.22],
            [0.2],
            [0.1],
            [0.37],
            [-0.05],
            [0.09],
            [0.42],
            [0.09],
            [0.13],
            [0.44],
            [-0.01],
            [-0.17],
            [-0.12],
            [0.14],
            [-0.16],
            [0.36],
            [0.08],
            [0.28],
            [-0.36],
            [0.07],
            [-0.28],
            [0.09],
            [-0.22],
            [-0],
            [-0.16],
            [-0.08],
            [-0.07],
            [0.09],
            [-0.19],
            [0.26],
            [0.01],
            [-0.34],
            [-0.28],
            [0.59],
            [-0.04],
            [0.08],
            [-0.56],
            [0.67],
            [-0.28],
            [0.26],
            [-0.35],
            [-0],
            [0.21],
            [-0.21],
            [-0.14],
            [0.36],
            [0.01],
            [0.49],
            [-0.1],
            [-0.07],
            [-0.42],
            [0.42],
            [-0.23],
            [0.25],
            [0.04],
            [0.35],
            [-0.64],
            [0.23],
            [-0.55],
            [0.34],
            [-0.16],
            [0.03],
            [-0.18],
            [0.44],
            [-0.23],
            [0.2],
            [-0.14],
            [0.13],
            [-0.08],
            [0.33],
            [0.13],
            [0.57],
            [-0.22],
            [0.26],
            [-0.02],
            [0.27],
            [-0.12],
            [0.05],
            [0.12],
            [0.3],
            [-0.3],
            [0.14],
            [0.09],
            [0.06],
            [-0.33],
            [-0.13],
            [-0.2],
            [0.26],
            [0.01],
            [-0.2],
            [0.21],
            [0.06],
            [-0.41],
            [0.25],
            [0.01],
            [0.33],
            [-0.4],
            [0.14],
            [-0.18],
            [0.22],
            [-0.19],
            [0.39],
            [-0.12],
            [-0.18],
            [0.22],
            [0.34],
            [-0.06],
            [0.28],
            [-0.46],
            [0.11],
            [0.21],
            [0.06],
            [-0.24],
            [0.15],
            [-0.4],
            [0.08],
            [0.15],
            [0.4],
            [-0.16],
            [-0.01],
            [-0.26],
            [0.08],
            [-0.21],
            [0.45],
            [-0.3],
            [-0.17],
            [0.08],
            [0.12],
            [-0.13],
            [0.21],
            [0.34],
            [0.2],
            [-0.35],
            [0.24],
            [-0.33],
            [-0.31],
            [-0.28],
            [0.19],
            [-0.43],
            [0.62],
            [-0.14],
            [0.26],
            [-0.21],
            [-0.14],
            [0.15],
            [0.27],
            [-0.04],
            [0.1],
            [-0],
            [-0.19],
            [0.2],
            [-0.06],
            [-0.14],
            [-0.02],
            [-0.49],
            [-0.21],
            [-0],
            [0.15],
            [-0.21],
            [-0.15],
            [-0.21],
            [0.36],
            [-0.07],
            [0.37],
            [-0.17],
            [0.2],
            [-0.06],
            [0.16],
            [-0.27],
            [0.06],
            [0.31],
            [0.07],
            [-0.24],
            [-0.3],
            [-0.43],
            [0.36],
            [-0.08],
            [0.19],
            [-0.09],
            [0.39],
            [-0.19],
            [0.01],
            [-0.15],
            [0.14],
            [-0.39],
            [-0.16],
            [-0.17],
            [0.18],
            [0.03],
            [0.2],
            [0.06],
            [-0.01],
            [0.13],
            [0.24],
            [-0.16],
            [-0.04],
            [-0.46],
            [0.36],
            [-0.2],
            [-0.11],
            [-0.24],
            [0.2],
            [-0.25],
            [0.35],
            [-0.03],
            [0.34],
            [-0.28],
            [0.42],
            [-0.4],
            [0.03],
            [0.32],
            [0.24],
            [0.14],
            [0.37],
            [0.02],
            [-0.05],
            [-0.3],
            [0.32],
            [-0.35],
            [0.42],
            [-0.35],
            [0.01],
            [-0.36],
            [0.01],
            [-0.25],
            [-0.3],
            [-0.2],
            [0.06],
            [-0.16],
            [0.72],
            [-0.35],
            [-0.21],
            [-0.04],
            [0.05],
            [0.03],
            [0.36],
            [0.06],
            [0.24],
            [-0.02],
            [0.17],
            [-0.26],
            [0.01],
            [-0.19],
            [0.38],
            [-0],
            [-0.13],
            [-0.03],
            [0.36],
            [0.02],
            [-0.17],
            [-0.32],
            [0.03],
            [-0.14],
            [0.43],
            [-0.08],
            [0.41],
            [-0.01],
            [0.05],
            [-0.17],
            [0.19],
            [-0.06],
            [0.15],
            [-0.27],
            [0.37],
            [-0.04],
            [0.56],
            [-0.2],
            [0.29],
            [-0.08],
            [-0.04],
            [-0.1],
            [0.34],
            [0.14],
            [0.22],
            [-0.19],
            [0.35],
            [-0.48],
            [0.09],
            [-0.17],
            [0.28],
            [-0.35],
            [0.17],
            [-0.38],
            [-0.1],
            [-0.54],
            [0.1],
            [-0.23],
            [0.27],
            [0.08],
            [0.36],
            [-0.03],
            [0.04],
            [-0.22],
            [-0.19],
            [-0.08],
            [0.39],
            [-0.22],
            [0.33],
            [-0.32],
            [0.1],
            [0.13],
            [0.23],
            [-0.07],
            [0.03],
            [-0.26],
            [0.47],
            [-0.03],
            [0.17],
            [0.32],
            [0.07],
            [0.15],
            [0.11],
            [-0.37],
            [0.06],
            [-0.15],
            [0.13],
            [-0.13],
            [0.23],
            [-0.18],
            [0.08],
            [-0.04],
            [0.38],
            [0.23],
            [-0.01],
            [-0.18],
            [-0.1],
            [-0.79],
            [0.41],
            [-0.06],
            [-0.03],
            [0.1],
            [0.21],
            [-0.3],
            [-0.06],
            [-0.28],
            [0.04],
            [-0.37],
            [0.02],
            [-0.21],
            [0.21],
            [-0.44],
            [0.21],
            [-0.35],
            [0.41],
            [-0.02],
            [0.32],
            [-0.05],
            [0.36],
            [0],
            [0.1],
            [-0.29],
            [-0.23],
            [-0.18],
            [-0.24],
            [-0.02],
            [-0.28],
            [-0.25],
            [0.23],
            [0.07],
            [0.27],
            [-0.05],
            [-0.07],
            [-0.35],
            [0.28],
            [-0.01],
            [0.31],
            [-0.18],
            [0.38],
            [-0.06],
            [0.05],
            [-0.13],
            [0.55],
            [0.23],
            [0.12],
            [-0.09],
            [0.43],
            [-0.44],
            [0.14],
            [-0.45],
            [0.35],
            [-0.1],
            [0.03],
            [-0.1],
            [-0.09],
            [-0.3],
            [0.35],
            [-0.26],
            [0.6],
            [-0.44],
            [0],
            [-0.4],
            [0.26],
            [0.07],
            [0.13],
            [-0.13],
            [0.01],
        ]; break;
    
        // Penguins
        // Horst AM, Hill AP, Gorman KB (2020).
        // palmerpenguins: Palmer Archipelago (Antarctica) penguin data. R package version 0.1.0.
        // https://allisonhorst.github.io/palmerpenguins/. doi: 10.5281/zenodo.3960218.
        case "Penguins": data = [
            [ "Adelie", "Torgersen", 39.1,18.7,181,3750, "Male" ],
            [ "Adelie", "Torgersen", 39.5,17.4,186,3800, "Female" ],
            [ "Adelie", "Torgersen", 40.3,18,195,3250, "Female" ],
//            [ "Adelie", "Torgersen", ,,,, ],
            [ "Adelie", "Torgersen", 36.7,19.3,193,3450, "Female" ],
            [ "Adelie", "Torgersen", 39.3,20.6,190,3650, "Male" ],
            [ "Adelie", "Torgersen", 38.9,17.8,181,3625, "Female" ],
            [ "Adelie", "Torgersen", 39.2,19.6,195,4675, "Male" ],
            [ "Adelie", "Torgersen", 34.1,18.1,193,3475, ],
            [ "Adelie", "Torgersen", 42,20.2,190,4250, ],
            [ "Adelie", "Torgersen", 37.8,17.1,186,3300, ],
            [ "Adelie", "Torgersen", 37.8,17.3,180,3700, ],
            [ "Adelie", "Torgersen", 41.1,17.6,182,3200, "Female" ],
            [ "Adelie", "Torgersen", 38.6,21.2,191,3800, "Male" ],
            [ "Adelie", "Torgersen", 34.6,21.1,198,4400, "Male" ],
            [ "Adelie", "Torgersen", 36.6,17.8,185,3700, "Female" ],
            [ "Adelie", "Torgersen", 38.7,19,195,3450, "Female" ],
            [ "Adelie", "Torgersen", 42.5,20.7,197,4500, "Male" ],
            [ "Adelie", "Torgersen", 34.4,18.4,184,3325, "Female" ],
            [ "Adelie", "Torgersen", 46,21.5,194,4200, "Male" ],
            [ "Adelie", "Biscoe", 37.8,18.3,174,3400, "Female" ],
            [ "Adelie", "Biscoe", 37.7,18.7,180,3600, "Male" ],
            [ "Adelie", "Biscoe", 35.9,19.2,189,3800, "Female" ],
            [ "Adelie", "Biscoe", 38.2,18.1,185,3950, "Male" ],
            [ "Adelie", "Biscoe", 38.8,17.2,180,3800, "Male" ],
            [ "Adelie", "Biscoe", 35.3,18.9,187,3800, "Female" ],
            [ "Adelie", "Biscoe", 40.6,18.6,183,3550, "Male" ],
            [ "Adelie", "Biscoe", 40.5,17.9,187,3200, "Female" ],
            [ "Adelie", "Biscoe", 37.9,18.6,172,3150, "Female" ],
            [ "Adelie", "Biscoe", 40.5,18.9,180,3950, "Male" ],
            [ "Adelie", "Dream", 39.5,16.7,178,3250, "Female" ],
            [ "Adelie", "Dream", 37.2,18.1,178,3900, "Male" ],
            [ "Adelie", "Dream", 39.5,17.8,188,3300, "Female" ],
            [ "Adelie", "Dream", 40.9,18.9,184,3900, "Male" ],
            [ "Adelie", "Dream", 36.4,17,195,3325, "Female" ],
            [ "Adelie", "Dream", 39.2,21.1,196,4150, "Male" ],
            [ "Adelie", "Dream", 38.8,20,190,3950, "Male" ],
            [ "Adelie", "Dream", 42.2,18.5,180,3550, "Female" ],
            [ "Adelie", "Dream", 37.6,19.3,181,3300, "Female" ],
            [ "Adelie", "Dream", 39.8,19.1,184,4650, "Male" ],
            [ "Adelie", "Dream", 36.5,18,182,3150, "Female" ],
            [ "Adelie", "Dream", 40.8,18.4,195,3900, "Male" ],
            [ "Adelie", "Dream", 36,18.5,186,3100, "Female" ],
            [ "Adelie", "Dream", 44.1,19.7,196,4400, "Male" ],
            [ "Adelie", "Dream", 37,16.9,185,3000, "Female" ],
            [ "Adelie", "Dream", 39.6,18.8,190,4600, "Male" ],
            [ "Adelie", "Dream", 41.1,19,182,3425, "Male" ],
            [ "Adelie", "Dream", 37.5,18.9,179,2975, ],
            [ "Adelie", "Dream", 36,17.9,190,3450, "Female" ],
            [ "Adelie", "Dream", 42.3,21.2,191,4150, "Male" ],
            [ "Adelie", "Biscoe", 39.6,17.7,186,3500, "Female" ],
            [ "Adelie", "Biscoe", 40.1,18.9,188,4300, "Male" ],
            [ "Adelie", "Biscoe", 35,17.9,190,3450, "Female" ],
            [ "Adelie", "Biscoe", 42,19.5,200,4050, "Male" ],
            [ "Adelie", "Biscoe", 34.5,18.1,187,2900, "Female" ],
            [ "Adelie", "Biscoe", 41.4,18.6,191,3700, "Male" ],
            [ "Adelie", "Biscoe", 39,17.5,186,3550, "Female" ],
            [ "Adelie", "Biscoe", 40.6,18.8,193,3800, "Male" ],
            [ "Adelie", "Biscoe", 36.5,16.6,181,2850, "Female" ],
            [ "Adelie", "Biscoe", 37.6,19.1,194,3750, "Male" ],
            [ "Adelie", "Biscoe", 35.7,16.9,185,3150, "Female" ],
            [ "Adelie", "Biscoe", 41.3,21.1,195,4400, "Male" ],
            [ "Adelie", "Biscoe", 37.6,17,185,3600, "Female" ],
            [ "Adelie", "Biscoe", 41.1,18.2,192,4050, "Male" ],
            [ "Adelie", "Biscoe", 36.4,17.1,184,2850, "Female" ],
            [ "Adelie", "Biscoe", 41.6,18,192,3950, "Male" ],
            [ "Adelie", "Biscoe", 35.5,16.2,195,3350, "Female" ],
            [ "Adelie", "Biscoe", 41.1,19.1,188,4100, "Male" ],
            [ "Adelie", "Torgersen", 35.9,16.6,190,3050, "Female" ],
            [ "Adelie", "Torgersen", 41.8,19.4,198,4450, "Male" ],
            [ "Adelie", "Torgersen", 33.5,19,190,3600, "Female" ],
            [ "Adelie", "Torgersen", 39.7,18.4,190,3900, "Male" ],
            [ "Adelie", "Torgersen", 39.6,17.2,196,3550, "Female" ],
            [ "Adelie", "Torgersen", 45.8,18.9,197,4150, "Male" ],
            [ "Adelie", "Torgersen", 35.5,17.5,190,3700, "Female" ],
            [ "Adelie", "Torgersen", 42.8,18.5,195,4250, "Male" ],
            [ "Adelie", "Torgersen", 40.9,16.8,191,3700, "Female" ],
            [ "Adelie", "Torgersen", 37.2,19.4,184,3900, "Male" ],
            [ "Adelie", "Torgersen", 36.2,16.1,187,3550, "Female" ],
            [ "Adelie", "Torgersen", 42.1,19.1,195,4000, "Male" ],
            [ "Adelie", "Torgersen", 34.6,17.2,189,3200, "Female" ],
            [ "Adelie", "Torgersen", 42.9,17.6,196,4700, "Male" ],
            [ "Adelie", "Torgersen", 36.7,18.8,187,3800, "Female" ],
            [ "Adelie", "Torgersen", 35.1,19.4,193,4200, "Male" ],
            [ "Adelie", "Dream", 37.3,17.8,191,3350, "Female" ],
            [ "Adelie", "Dream", 41.3,20.3,194,3550, "Male" ],
            [ "Adelie", "Dream", 36.3,19.5,190,3800, "Male" ],
            [ "Adelie", "Dream", 36.9,18.6,189,3500, "Female" ],
            [ "Adelie", "Dream", 38.3,19.2,189,3950, "Male" ],
            [ "Adelie", "Dream", 38.9,18.8,190,3600, "Female" ],
            [ "Adelie", "Dream", 35.7,18,202,3550, "Female" ],
            [ "Adelie", "Dream", 41.1,18.1,205,4300, "Male" ],
            [ "Adelie", "Dream", 34,17.1,185,3400, "Female" ],
            [ "Adelie", "Dream", 39.6,18.1,186,4450, "Male" ],
            [ "Adelie", "Dream", 36.2,17.3,187,3300, "Female" ],
            [ "Adelie", "Dream", 40.8,18.9,208,4300, "Male" ],
            [ "Adelie", "Dream", 38.1,18.6,190,3700, "Female" ],
            [ "Adelie", "Dream", 40.3,18.5,196,4350, "Male" ],
            [ "Adelie", "Dream", 33.1,16.1,178,2900, "Female" ],
            [ "Adelie", "Dream", 43.2,18.5,192,4100, "Male" ],
            [ "Adelie", "Biscoe", 35,17.9,192,3725, "Female" ],
            [ "Adelie", "Biscoe", 41,20,203,4725, "Male" ],
            [ "Adelie", "Biscoe", 37.7,16,183,3075, "Female" ],
            [ "Adelie", "Biscoe", 37.8,20,190,4250, "Male" ],
            [ "Adelie", "Biscoe", 37.9,18.6,193,2925, "Female" ],
            [ "Adelie", "Biscoe", 39.7,18.9,184,3550, "Male" ],
            [ "Adelie", "Biscoe", 38.6,17.2,199,3750, "Female" ],
            [ "Adelie", "Biscoe", 38.2,20,190,3900, "Male" ],
            [ "Adelie", "Biscoe", 38.1,17,181,3175, "Female" ],
            [ "Adelie", "Biscoe", 43.2,19,197,4775, "Male" ],
            [ "Adelie", "Biscoe", 38.1,16.5,198,3825, "Female" ],
            [ "Adelie", "Biscoe", 45.6,20.3,191,4600, "Male" ],
            [ "Adelie", "Biscoe", 39.7,17.7,193,3200, "Female" ],
            [ "Adelie", "Biscoe", 42.2,19.5,197,4275, "Male" ],
            [ "Adelie", "Biscoe", 39.6,20.7,191,3900, "Female" ],
            [ "Adelie", "Biscoe", 42.7,18.3,196,4075, "Male" ],
            [ "Adelie", "Torgersen", 38.6,17,188,2900, "Female" ],
            [ "Adelie", "Torgersen", 37.3,20.5,199,3775, "Male" ],
            [ "Adelie", "Torgersen", 35.7,17,189,3350, "Female" ],
            [ "Adelie", "Torgersen", 41.1,18.6,189,3325, "Male" ],
            [ "Adelie", "Torgersen", 36.2,17.2,187,3150, "Female" ],
            [ "Adelie", "Torgersen", 37.7,19.8,198,3500, "Male" ],
            [ "Adelie", "Torgersen", 40.2,17,176,3450, "Female" ],
            [ "Adelie", "Torgersen", 41.4,18.5,202,3875, "Male" ],
            [ "Adelie", "Torgersen", 35.2,15.9,186,3050, "Female" ],
            [ "Adelie", "Torgersen", 40.6,19,199,4000, "Male" ],
            [ "Adelie", "Torgersen", 38.8,17.6,191,3275, "Female" ],
            [ "Adelie", "Torgersen", 41.5,18.3,195,4300, "Male" ],
            [ "Adelie", "Torgersen", 39,17.1,191,3050, "Female" ],
            [ "Adelie", "Torgersen", 44.1,18,210,4000, "Male" ],
            [ "Adelie", "Torgersen", 38.5,17.9,190,3325, "Female" ],
            [ "Adelie", "Torgersen", 43.1,19.2,197,3500, "Male" ],
            [ "Adelie", "Dream", 36.8,18.5,193,3500, "Female" ],
            [ "Adelie", "Dream", 37.5,18.5,199,4475, "Male" ],
            [ "Adelie", "Dream", 38.1,17.6,187,3425, "Female" ],
            [ "Adelie", "Dream", 41.1,17.5,190,3900, "Male" ],
            [ "Adelie", "Dream", 35.6,17.5,191,3175, "Female" ],
            [ "Adelie", "Dream", 40.2,20.1,200,3975, "Male" ],
            [ "Adelie", "Dream", 37,16.5,185,3400, "Female" ],
            [ "Adelie", "Dream", 39.7,17.9,193,4250, "Male" ],
            [ "Adelie", "Dream", 40.2,17.1,193,3400, "Female" ],
            [ "Adelie", "Dream", 40.6,17.2,187,3475, "Male" ],
            [ "Adelie", "Dream", 32.1,15.5,188,3050, "Female" ],
            [ "Adelie", "Dream", 40.7,17,190,3725, "Male" ],
            [ "Adelie", "Dream", 37.3,16.8,192,3000, "Female" ],
            [ "Adelie", "Dream", 39,18.7,185,3650, "Male" ],
            [ "Adelie", "Dream", 39.2,18.6,190,4250, "Male" ],
            [ "Adelie", "Dream", 36.6,18.4,184,3475, "Female" ],
            [ "Adelie", "Dream", 36,17.8,195,3450, "Female" ],
            [ "Adelie", "Dream", 37.8,18.1,193,3750, "Male" ],
            [ "Adelie", "Dream", 36,17.1,187,3700, "Female" ],
            [ "Adelie", "Dream", 41.5,18.5,201,4000, "Male" ],
            [ "Chinstrap", "Dream", 46.5,17.9,192,3500, "Female" ],
            [ "Chinstrap", "Dream", 50,19.5,196,3900, "Male" ],
            [ "Chinstrap", "Dream", 51.3,19.2,193,3650, "Male" ],
            [ "Chinstrap", "Dream", 45.4,18.7,188,3525, "Female" ],
            [ "Chinstrap", "Dream", 52.7,19.8,197,3725, "Male" ],
            [ "Chinstrap", "Dream", 45.2,17.8,198,3950, "Female" ],
            [ "Chinstrap", "Dream", 46.1,18.2,178,3250, "Female" ],
            [ "Chinstrap", "Dream", 51.3,18.2,197,3750, "Male" ],
            [ "Chinstrap", "Dream", 46,18.9,195,4150, "Female" ],
            [ "Chinstrap", "Dream", 51.3,19.9,198,3700, "Male" ],
            [ "Chinstrap", "Dream", 46.6,17.8,193,3800, "Female" ],
            [ "Chinstrap", "Dream", 51.7,20.3,194,3775, "Male" ],
            [ "Chinstrap", "Dream", 47,17.3,185,3700, "Female" ],
            [ "Chinstrap", "Dream", 52,18.1,201,4050, "Male" ],
            [ "Chinstrap", "Dream", 45.9,17.1,190,3575, "Female" ],
            [ "Chinstrap", "Dream", 50.5,19.6,201,4050, "Male" ],
            [ "Chinstrap", "Dream", 50.3,20,197,3300, "Male" ],
            [ "Chinstrap", "Dream", 58,17.8,181,3700, "Female" ],
            [ "Chinstrap", "Dream", 46.4,18.6,190,3450, "Female" ],
            [ "Chinstrap", "Dream", 49.2,18.2,195,4400, "Male" ],
            [ "Chinstrap", "Dream", 42.4,17.3,181,3600, "Female" ],
            [ "Chinstrap", "Dream", 48.5,17.5,191,3400, "Male" ],
            [ "Chinstrap", "Dream", 43.2,16.6,187,2900, "Female" ],
            [ "Chinstrap", "Dream", 50.6,19.4,193,3800, "Male" ],
            [ "Chinstrap", "Dream", 46.7,17.9,195,3300, "Female" ],
            [ "Chinstrap", "Dream", 52,19,197,4150, "Male" ],
            [ "Chinstrap", "Dream", 50.5,18.4,200,3400, "Female" ],
            [ "Chinstrap", "Dream", 49.5,19,200,3800, "Male" ],
            [ "Chinstrap", "Dream", 46.4,17.8,191,3700, "Female" ],
            [ "Chinstrap", "Dream", 52.8,20,205,4550, "Male" ],
            [ "Chinstrap", "Dream", 40.9,16.6,187,3200, "Female" ],
            [ "Chinstrap", "Dream", 54.2,20.8,201,4300, "Male" ],
            [ "Chinstrap", "Dream", 42.5,16.7,187,3350, "Female" ],
            [ "Chinstrap", "Dream", 51,18.8,203,4100, "Male" ],
            [ "Chinstrap", "Dream", 49.7,18.6,195,3600, "Male" ],
            [ "Chinstrap", "Dream", 47.5,16.8,199,3900, "Female" ],
            [ "Chinstrap", "Dream", 47.6,18.3,195,3850, "Female" ],
            [ "Chinstrap", "Dream", 52,20.7,210,4800, "Male" ],
            [ "Chinstrap", "Dream", 46.9,16.6,192,2700, "Female" ],
            [ "Chinstrap", "Dream", 53.5,19.9,205,4500, "Male" ],
            [ "Chinstrap", "Dream", 49,19.5,210,3950, "Male" ],
            [ "Chinstrap", "Dream", 46.2,17.5,187,3650, "Female" ],
            [ "Chinstrap", "Dream", 50.9,19.1,196,3550, "Male" ],
            [ "Chinstrap", "Dream", 45.5,17,196,3500, "Female" ],
            [ "Chinstrap", "Dream", 50.9,17.9,196,3675, "Female" ],
            [ "Chinstrap", "Dream", 50.8,18.5,201,4450, "Male" ],
            [ "Chinstrap", "Dream", 50.1,17.9,190,3400, "Female" ],
            [ "Chinstrap", "Dream", 49,19.6,212,4300, "Male" ],
            [ "Chinstrap", "Dream", 51.5,18.7,187,3250, "Male" ],
            [ "Chinstrap", "Dream", 49.8,17.3,198,3675, "Female" ],
            [ "Chinstrap", "Dream", 48.1,16.4,199,3325, "Female" ],
            [ "Chinstrap", "Dream", 51.4,19,201,3950, "Male" ],
            [ "Chinstrap", "Dream", 45.7,17.3,193,3600, "Female" ],
            [ "Chinstrap", "Dream", 50.7,19.7,203,4050, "Male" ],
            [ "Chinstrap", "Dream", 42.5,17.3,187,3350, "Female" ],
            [ "Chinstrap", "Dream", 52.2,18.8,197,3450, "Male" ],
            [ "Chinstrap", "Dream", 45.2,16.6,191,3250, "Female" ],
            [ "Chinstrap", "Dream", 49.3,19.9,203,4050, "Male" ],
            [ "Chinstrap", "Dream", 50.2,18.8,202,3800, "Male" ],
            [ "Chinstrap", "Dream", 45.6,19.4,194,3525, "Female" ],
            [ "Chinstrap", "Dream", 51.9,19.5,206,3950, "Male" ],
            [ "Chinstrap", "Dream", 46.8,16.5,189,3650, "Female" ],
            [ "Chinstrap", "Dream", 45.7,17,195,3650, "Female" ],
            [ "Chinstrap", "Dream", 55.8,19.8,207,4000, "Male" ],
            [ "Chinstrap", "Dream", 43.5,18.1,202,3400, "Female" ],
            [ "Chinstrap", "Dream", 49.6,18.2,193,3775, "Male" ],
            [ "Chinstrap", "Dream", 50.8,19,210,4100, "Male" ],
            [ "Chinstrap", "Dream", 50.2,18.7,198,3775, "Female" ],
            [ "Gentoo", "Biscoe", 46.1,13.2,211,4500, "Female" ],
            [ "Gentoo", "Biscoe", 50,16.3,230,5700, "Male" ],
            [ "Gentoo", "Biscoe", 48.7,14.1,210,4450, "Female" ],
            [ "Gentoo", "Biscoe", 50,15.2,218,5700, "Male" ],
            [ "Gentoo", "Biscoe", 47.6,14.5,215,5400, "Male" ],
            [ "Gentoo", "Biscoe", 46.5,13.5,210,4550, "Female" ],
            [ "Gentoo", "Biscoe", 45.4,14.6,211,4800, "Female" ],
            [ "Gentoo", "Biscoe", 46.7,15.3,219,5200, "Male" ],
            [ "Gentoo", "Biscoe", 43.3,13.4,209,4400, "Female" ],
            [ "Gentoo", "Biscoe", 46.8,15.4,215,5150, "Male" ],
            [ "Gentoo", "Biscoe", 40.9,13.7,214,4650, "Female" ],
            [ "Gentoo", "Biscoe", 49,16.1,216,5550, "Male" ],
            [ "Gentoo", "Biscoe", 45.5,13.7,214,4650, "Female" ],
            [ "Gentoo", "Biscoe", 48.4,14.6,213,5850, "Male" ],
            [ "Gentoo", "Biscoe", 45.8,14.6,210,4200, "Female" ],
            [ "Gentoo", "Biscoe", 49.3,15.7,217,5850, "Male" ],
            [ "Gentoo", "Biscoe", 42,13.5,210,4150, "Female" ],
            [ "Gentoo", "Biscoe", 49.2,15.2,221,6300, "Male" ],
            [ "Gentoo", "Biscoe", 46.2,14.5,209,4800, "Female" ],
            [ "Gentoo", "Biscoe", 48.7,15.1,222,5350, "Male" ],
            [ "Gentoo", "Biscoe", 50.2,14.3,218,5700, "Male" ],
            [ "Gentoo", "Biscoe", 45.1,14.5,215,5000, "Female" ],
            [ "Gentoo", "Biscoe", 46.5,14.5,213,4400, "Female" ],
            [ "Gentoo", "Biscoe", 46.3,15.8,215,5050, "Male" ],
            [ "Gentoo", "Biscoe", 42.9,13.1,215,5000, "Female" ],
            [ "Gentoo", "Biscoe", 46.1,15.1,215,5100, "Male" ],
            [ "Gentoo", "Biscoe", 44.5,14.3,216,4100, ],
            [ "Gentoo", "Biscoe", 47.8,15,215,5650, "Male" ],
            [ "Gentoo", "Biscoe", 48.2,14.3,210,4600, "Female" ],
            [ "Gentoo", "Biscoe", 50,15.3,220,5550, "Male" ],
            [ "Gentoo", "Biscoe", 47.3,15.3,222,5250, "Male" ],
            [ "Gentoo", "Biscoe", 42.8,14.2,209,4700, "Female" ],
            [ "Gentoo", "Biscoe", 45.1,14.5,207,5050, "Female" ],
            [ "Gentoo", "Biscoe", 59.6,17,230,6050, "Male" ],
            [ "Gentoo", "Biscoe", 49.1,14.8,220,5150, "Female" ],
            [ "Gentoo", "Biscoe", 48.4,16.3,220,5400, "Male" ],
            [ "Gentoo", "Biscoe", 42.6,13.7,213,4950, "Female" ],
            [ "Gentoo", "Biscoe", 44.4,17.3,219,5250, "Male" ],
            [ "Gentoo", "Biscoe", 44,13.6,208,4350, "Female" ],
            [ "Gentoo", "Biscoe", 48.7,15.7,208,5350, "Male" ],
            [ "Gentoo", "Biscoe", 42.7,13.7,208,3950, "Female" ],
            [ "Gentoo", "Biscoe", 49.6,16,225,5700, "Male" ],
            [ "Gentoo", "Biscoe", 45.3,13.7,210,4300, "Female" ],
            [ "Gentoo", "Biscoe", 49.6,15,216,4750, "Male" ],
            [ "Gentoo", "Biscoe", 50.5,15.9,222,5550, "Male" ],
            [ "Gentoo", "Biscoe", 43.6,13.9,217,4900, "Female" ],
            [ "Gentoo", "Biscoe", 45.5,13.9,210,4200, "Female" ],
            [ "Gentoo", "Biscoe", 50.5,15.9,225,5400, "Male" ],
            [ "Gentoo", "Biscoe", 44.9,13.3,213,5100, "Female" ],
            [ "Gentoo", "Biscoe", 45.2,15.8,215,5300, "Male" ],
            [ "Gentoo", "Biscoe", 46.6,14.2,210,4850, "Female" ],
            [ "Gentoo", "Biscoe", 48.5,14.1,220,5300, "Male" ],
            [ "Gentoo", "Biscoe", 45.1,14.4,210,4400, "Female" ],
            [ "Gentoo", "Biscoe", 50.1,15,225,5000, "Male" ],
            [ "Gentoo", "Biscoe", 46.5,14.4,217,4900, "Female" ],
            [ "Gentoo", "Biscoe", 45,15.4,220,5050, "Male" ],
            [ "Gentoo", "Biscoe", 43.8,13.9,208,4300, "Female" ],
            [ "Gentoo", "Biscoe", 45.5,15,220,5000, "Male" ],
            [ "Gentoo", "Biscoe", 43.2,14.5,208,4450, "Female" ],
            [ "Gentoo", "Biscoe", 50.4,15.3,224,5550, "Male" ],
            [ "Gentoo", "Biscoe", 45.3,13.8,208,4200, "Female" ],
            [ "Gentoo", "Biscoe", 46.2,14.9,221,5300, "Male" ],
            [ "Gentoo", "Biscoe", 45.7,13.9,214,4400, "Female" ],
            [ "Gentoo", "Biscoe", 54.3,15.7,231,5650, "Male" ],
            [ "Gentoo", "Biscoe", 45.8,14.2,219,4700, "Female" ],
            [ "Gentoo", "Biscoe", 49.8,16.8,230,5700, "Male" ],
            [ "Gentoo", "Biscoe", 46.2,14.4,214,4650, ],
            [ "Gentoo", "Biscoe", 49.5,16.2,229,5800, "Male" ],
            [ "Gentoo", "Biscoe", 43.5,14.2,220,4700, "Female" ],
            [ "Gentoo", "Biscoe", 50.7,15,223,5550, "Male" ],
            [ "Gentoo", "Biscoe", 47.7,15,216,4750, "Female" ],
            [ "Gentoo", "Biscoe", 46.4,15.6,221,5000, "Male" ],
            [ "Gentoo", "Biscoe", 48.2,15.6,221,5100, "Male" ],
            [ "Gentoo", "Biscoe", 46.5,14.8,217,5200, "Female" ],
            [ "Gentoo", "Biscoe", 46.4,15,216,4700, "Female" ],
            [ "Gentoo", "Biscoe", 48.6,16,230,5800, "Male" ],
            [ "Gentoo", "Biscoe", 47.5,14.2,209,4600, "Female" ],
            [ "Gentoo", "Biscoe", 51.1,16.3,220,6000, "Male" ],
            [ "Gentoo", "Biscoe", 45.2,13.8,215,4750, "Female" ],
            [ "Gentoo", "Biscoe", 45.2,16.4,223,5950, "Male" ],
            [ "Gentoo", "Biscoe", 49.1,14.5,212,4625, "Female" ],
            [ "Gentoo", "Biscoe", 52.5,15.6,221,5450, "Male" ],
            [ "Gentoo", "Biscoe", 47.4,14.6,212,4725, "Female" ],
            [ "Gentoo", "Biscoe", 50,15.9,224,5350, "Male" ],
            [ "Gentoo", "Biscoe", 44.9,13.8,212,4750, "Female" ],
            [ "Gentoo", "Biscoe", 50.8,17.3,228,5600, "Male" ],
            [ "Gentoo", "Biscoe", 43.4,14.4,218,4600, "Female" ],
            [ "Gentoo", "Biscoe", 51.3,14.2,218,5300, "Male" ],
            [ "Gentoo", "Biscoe", 47.5,14,212,4875, "Female" ],
            [ "Gentoo", "Biscoe", 52.1,17,230,5550, "Male" ],
            [ "Gentoo", "Biscoe", 47.5,15,218,4950, "Female" ],
            [ "Gentoo", "Biscoe", 52.2,17.1,228,5400, "Male" ],
            [ "Gentoo", "Biscoe", 45.5,14.5,212,4750, "Female" ],
            [ "Gentoo", "Biscoe", 49.5,16.1,224,5650, "Male" ],
            [ "Gentoo", "Biscoe", 44.5,14.7,214,4850, "Female" ],
            [ "Gentoo", "Biscoe", 50.8,15.7,226,5200, "Male" ],
            [ "Gentoo", "Biscoe", 49.4,15.8,216,4925, "Male" ],
            [ "Gentoo", "Biscoe", 46.9,14.6,222,4875, "Female" ],
            [ "Gentoo", "Biscoe", 48.4,14.4,203,4625, "Female" ],
            [ "Gentoo", "Biscoe", 51.1,16.5,225,5250, "Male" ],
            [ "Gentoo", "Biscoe", 48.5,15,219,4850, "Female" ],
            [ "Gentoo", "Biscoe", 55.9,17,228,5600, "Male" ],
            [ "Gentoo", "Biscoe", 47.2,15.5,215,4975, "Female" ],
            [ "Gentoo", "Biscoe", 49.1,15,228,5500, "Male" ],
            [ "Gentoo", "Biscoe", 47.3,13.8,216,4725, ],
            [ "Gentoo", "Biscoe", 46.8,16.1,215,5500, "Male" ],
            [ "Gentoo", "Biscoe", 41.7,14.7,210,4700, "Female" ],
            [ "Gentoo", "Biscoe", 53.4,15.8,219,5500, "Male" ],
            [ "Gentoo", "Biscoe", 43.3,14,208,4575, "Female" ],
            [ "Gentoo", "Biscoe", 48.1,15.1,209,5500, "Male" ],
            [ "Gentoo", "Biscoe", 50.5,15.2,216,5000, "Female" ],
            [ "Gentoo", "Biscoe", 49.8,15.9,229,5950, "Male" ],
            [ "Gentoo", "Biscoe", 43.5,15.2,213,4650, "Female" ],
            [ "Gentoo", "Biscoe", 51.5,16.3,230,5500, "Male" ],
            [ "Gentoo", "Biscoe", 46.2,14.1,217,4375, "Female" ],
            [ "Gentoo", "Biscoe", 55.1,16,230,5850, "Male" ],
            [ "Gentoo", "Biscoe", 44.5,15.7,217,4875, ],
            [ "Gentoo", "Biscoe", 48.8,16.2,222,6000, "Male" ],
            [ "Gentoo", "Biscoe", 47.2,13.7,214,4925, "Female" ],
//            [ "Gentoo", "Biscoe", ,,,, ],
            [ "Gentoo", "Biscoe", 46.8,14.3,215,4850, "Female" ],
            [ "Gentoo", "Biscoe", 50.4,15.7,222,5750, "Male" ],
            [ "Gentoo", "Biscoe", 45.2,14.8,212,5200, "Female" ],
            [ "Gentoo", "Biscoe", 49.9,16.1,213,5400, "Male" ],
        ]; break;
        
        // US Car Sales (https://www.goodcarbadcar.net/2022-us-passenger-car-sales-figures-by-model/).
        case "Sales": data = [
            [ "Toyota Camry", 19665 ],
            [ "Toyota Camry", 15612 ],
            [ "Toyota Camry", 26228 ],
            [ "Toyota Corolla", 15368 ],
            [ "Toyota Corolla", 15222 ],
            [ "Toyota Corolla", 16911 ],
            [ "Honda Accord", 10410 ],
            [ "Honda Accord", 13971 ],
            [ "Honda Accord", 17658 ],
            [ "Tesla Model 3", 13739 ],
            [ "Tesla Model 3", 13230 ],
            [ "Tesla Model 3", 13230 ],
            [ "Honda Civic", 13599 ],
            [ "Honda Civic", 14472 ],
            [ "Honda Civic", 10444 ],
            [ "Nissan Altima", 12254 ],
            [ "Nissan Altima", 12254 ],
            [ "Nissan Altima", 13786 ],
            [ "Nissan Sentra", 8682 ],
            [ "Nissan Sentra", 8682 ],
            [ "Nissan Sentra", 9767 ],
            [ "Chevrolet Malibu", 8218 ],
            [ "Chevrolet Malibu", 8218 ],
            [ "Chevrolet Malibu", 9246 ],
            [ "Kia Forte", 5748 ],
            [ "Kia Forte", 8141 ],
            [ "Kia Forte", 9609 ],
            [ "Hyundai Elantra", 5081 ],
            [ "Hyundai Elantra", 6786 ],
            [ "Hyundai Elantra", 10205 ],
            [ "Kia K5", 5794 ],
            [ "Kia K5", 6558 ],
            [ "Kia K5", 5470 ],
            [ "Dodge Charger", 4940 ],
            [ "Dodge Charger", 4940 ],
            [ "Dodge Charger", 5558 ],
            [ "Kia Soul", 3890 ],
            [ "Kia Soul", 5059 ],
            [ "Kia Soul", 5175 ],
            [ "Ford Mustang", 5671 ],
            [ "Ford Mustang", 4700 ],
            [ "Ford Mustang", 3615 ],
            [ "Tesla Model S", 3930 ],
            [ "Tesla Model S", 3785 ],
            [ "Tesla Model S", 3785 ],
            [ "Dodge Challenger", 3560 ],
            [ "Dodge Challenger", 3560 ],
            [ "Dodge Challenger", 4005 ],
            [ "Volkswagen Jetta", 3481 ],
            [ "Volkswagen Jetta", 3481 ],
            [ "Volkswagen Jetta", 3916 ],
            [ "Lexus ES", 2944 ],
            [ "Lexus ES", 3284 ],
            [ "Lexus ES", 3823 ],
            [ "Mazda 3", 3470 ],
            [ "Mazda 3", 2969 ],
            [ "Mazda 3", 3053 ],
            [ "Chevrolet Corvette", 2820 ],
            [ "Chevrolet Corvette", 2820 ],
            [ "Chevrolet Corvette", 3172 ],
            [ "Subaru Impreza", 2939 ],
            [ "Subaru Impreza", 3520 ],
            [ "Subaru Impreza", 2329 ],
            [ "BMW 3-Series", 2610 ],
            [ "BMW 3-Series", 2610 ],
            [ "BMW 3-Series", 2936 ],
            [ "BMW 4-Series", 2361 ],
            [ "BMW 4-Series", 2361 ],
            [ "BMW 4-Series", 2656 ],
            [ "Toyota Prius Family", 0 ],
            [ "Toyota Prius Family", 3080 ],
            [ "Toyota Prius Family", 3631 ],
            [ "Chevrolet Camaro", 2147 ],
            [ "Chevrolet Camaro", 2147 ],
            [ "Chevrolet Camaro", 2416 ],
            [ "Kia Rio", 1633 ],
            [ "Kia Rio", 2045 ],
            [ "Kia Rio", 2829 ],
            [ "BMW 5-Series", 1806 ],
            [ "BMW 5-Series", 1806 ],
            [ "BMW 5-Series", 2032 ],
            [ "Subaru Legacy", 1492 ],
            [ "Subaru Legacy", 1417 ],
            [ "Subaru Legacy", 2611 ],
            [ "Mitsubishi Mirage", 1573 ],
            [ "Mitsubishi Mirage", 1573 ],
            [ "Mitsubishi Mirage", 1770 ],
            [ "Mercedes-Benz S", 1541 ],
            [ "Mercedes-Benz S", 1541 ],
            [ "Mercedes-Benz S", 1734 ],
            [ "Hyundai Sonata", 0 ],
            [ "Hyundai Sonata", 3037 ],
            [ "Hyundai Sonata", 1716 ],
            [ "Mercedes-Benz E / CLS", 1514 ],
            [ "Mercedes-Benz E / CLS", 1514 ],
            [ "Mercedes-Benz E / CLS", 1703 ],
            [ "Lexus IS", 1708 ],
            [ "Lexus IS", 1184 ],
            [ "Lexus IS", 1570 ],
            [ "Nissan Leaf", 1399 ],
            [ "Nissan Leaf", 1399 ],
            [ "Nissan Leaf", 1574 ],
            [ "BMW 2-Series", 1288 ],
            [ "BMW 2-Series", 1288 ],
            [ "BMW 2-Series", 1449 ],
            [ "Mini Cooper", 1241 ],
            [ "Mini Cooper", 1241 ],
            [ "Mini Cooper", 1396 ],
            [ "Audi A4", 1233 ],
            [ "Audi A4", 1233 ],
            [ "Audi A4", 1387 ],
            [ "Audi A5", 1229 ],
            [ "Audi A5", 1229 ],
            [ "Audi A5", 1383 ],
            [ "Acura ILX", 1045 ],
            [ "Acura ILX", 1223 ],
            [ "Acura ILX", 1493 ],
            [ "Hyundai Ioniq", 1415 ],
            [ "Hyundai Ioniq", 1269 ],
            [ "Hyundai Ioniq", 860 ],
            [ "Cadillac CT5", 1070 ],
            [ "Cadillac CT5", 1070 ],
            [ "Cadillac CT5", 1203 ],
            [ "Toyota GR86", 1331 ],
            [ "Toyota GR86", 925 ],
            [ "Toyota GR86", 1001 ],
            [ "Kia Stinger", 991 ],
            [ "Kia Stinger", 1090 ],
            [ "Kia Stinger", 1026 ],
            [ "Acura TLX", 224 ],
            [ "Acura TLX", 985 ],
            [ "Acura TLX", 1782 ],
            [ "Genesis G70", 681 ],
            [ "Genesis G70", 895 ],
            [ "Genesis G70", 1297 ],
            [ "Nissan Maxima", 918 ],
            [ "Nissan Maxima", 918 ],
            [ "Nissan Maxima", 1033 ],
            [ "Volvo 60-Series", 1263 ],
            [ "Volvo 60-Series", 592 ],
            [ "Volvo 60-Series", 965 ],
            [ "Chrysler 300", 878 ],
            [ "Chrysler 300", 878 ],
            [ "Chrysler 300", 988 ],
            [ "Hyundai Accent", 507 ],
            [ "Hyundai Accent", 744 ],
            [ "Hyundai Accent", 1446 ],
            [ "Infiniti Q50", 777 ],
            [ "Infiniti Q50", 777 ],
            [ "Infiniti Q50", 874 ],
            [ "Volkswagen Passat", 750 ],
            [ "Volkswagen Passat", 750 ],
            [ "Volkswagen Passat", 844 ],
            [ "Nissan Versa", 746 ],
            [ "Nissan Versa", 746 ],
            [ "Nissan Versa", 839 ],
            [ "Volkswagen Golf", 743 ],
            [ "Volkswagen Golf", 743 ],
            [ "Volkswagen Golf", 836 ],
            [ "Toyota Avalon", 892 ],
            [ "Toyota Avalon", 537 ],
            [ "Toyota Avalon", 726 ],
            [ "Porsche 911", 682 ],
            [ "Porsche 911", 682 ],
            [ "Porsche 911", 768 ],
            [ "Porsche Taycan", 616 ],
            [ "Porsche Taycan", 616 ],
            [ "Porsche Taycan", 693 ],
            [ "Cadillac CT4", 606 ],
            [ "Cadillac CT4", 606 ],
            [ "Cadillac CT4", 681 ],
            [ "Honda Insight", 556 ],
            [ "Honda Insight", 546 ],
            [ "Honda Insight", 763 ],
            [ "Mazda MX-5 Miata", 386 ],
            [ "Mazda MX-5 Miata", 556 ],
            [ "Mazda MX-5 Miata", 663 ],
            [ "BMW 7-Series", 479 ],
            [ "BMW 7-Series", 479 ],
            [ "BMW 7-Series", 539 ],
            [ "BMW 8-Series", 448 ],
            [ "BMW 8-Series", 448 ],
            [ "BMW 8-Series", 504 ],
            [ "Audi A3", 438 ],
            [ "Audi A3", 438 ],
            [ "Audi A3", 492 ],
            [ "Audi A6", 408 ],
            [ "Audi A6", 408 ],
            [ "Audi A6", 459 ],
            [ "Alfa Romeo Giulia", 366 ],
            [ "Alfa Romeo Giulia", 366 ],
            [ "Alfa Romeo Giulia", 412 ],
            [ "Mercedes-Benz A", 360 ],
            [ "Mercedes-Benz A", 360 ],
            [ "Mercedes-Benz A", 405 ],
            [ "Toyota Supra", 370 ],
            [ "Toyota Supra", 298 ],
            [ "Toyota Supra", 439 ],
            [ "Mercedes-Benz CLA", 340 ],
            [ "Mercedes-Benz CLA", 340 ],
            [ "Mercedes-Benz CLA", 383 ],
            [ "Genesis G80", 405 ],
            [ "Genesis G80", 263 ],
            [ "Genesis G80", 380 ],
            [ "Subaru BRZ", 331 ],
            [ "Subaru BRZ", 349 ],
            [ "Subaru BRZ", 291 ],
            [ "Mercedes-Benz AMG GT", 301 ],
            [ "Mercedes-Benz AMG GT", 301 ],
            [ "Mercedes-Benz AMG GT", 339 ],
            [ "Porsche Panamera", 252 ],
            [ "Porsche Panamera", 252 ],
            [ "Porsche Panamera", 283 ],
            [ "Porsche 718", 250 ],
            [ "Porsche 718", 250 ],
            [ "Porsche 718", 282 ],
            [ "Infiniti Q60", 246 ],
            [ "Infiniti Q60", 246 ],
            [ "Infiniti Q60", 276 ],
            [ "Toyota Mirai", 134 ],
            [ "Toyota Mirai", 175 ],
            [ "Toyota Mirai", 406 ],
            [ "Audi e-Tron Sportback", 209 ],
            [ "Audi e-Tron Sportback", 209 ],
            [ "Audi e-Tron Sportback", 234 ],
            [ "Lexus LS", 203 ],
            [ "Lexus LS", 200 ],
            [ "Lexus LS", 186 ],
            [ "Subaru Impreza WRX", 341 ],
            [ "Subaru Impreza WRX", 31 ],
            [ "Subaru Impreza WRX", 204 ],
            [ "Audi e-Tron GT", 183 ],
            [ "Audi e-Tron GT", 183 ],
            [ "Audi e-Tron GT", 206 ],
            [ "Audi A7", 161 ],
            [ "Audi A7", 161 ],
            [ "Audi A7", 181 ],
            [ "Volvo 90-Series", 154 ],
            [ "Volvo 90-Series", 147 ],
            [ "Volvo 90-Series", 197 ],
            [ "Mercedes-Benz C", 158 ],
            [ "Mercedes-Benz C", 158 ],
            [ "Mercedes-Benz C", 178 ],
            [ "Lexus RC", 159 ],
            [ "Lexus RC", 137 ],
            [ "Lexus RC", 165 ],
            [ "Lexus LC", 146 ],
            [ "Lexus LC", 143 ],
            [ "Lexus LC", 153 ],
            [ "Genesis G90", 187 ],
            [ "Genesis G90", 145 ],
            [ "Genesis G90", 97 ],
            [ "Hyundai Veloster", 86 ],
            [ "Hyundai Veloster", 171 ],
            [ "Hyundai Veloster", 171 ],
            [ "Jaguar F-Type", 128 ],
            [ "Jaguar F-Type", 128 ],
            [ "Jaguar F-Type", 144 ],
            [ "Jaguar XF", 128 ],
            [ "Jaguar XF", 128 ],
            [ "Jaguar XF", 144 ],
            [ "Chevrolet Bolt", 115 ],
            [ "Chevrolet Bolt", 115 ],
            [ "Chevrolet Bolt", 129 ],
            [ "Fiat 500", 107 ],
            [ "Fiat 500", 107 ],
            [ "Fiat 500", 120 ],
            [ "Mazda 6", 256 ],
            [ "Mazda 6", 55 ],
            [ "Mazda 6", 14 ],
            [ "BMW Z4", 89 ],
            [ "BMW Z4", 89 ],
            [ "BMW Z4", 100 ],
            [ "Chevrolet Spark", 89 ],
            [ "Chevrolet Spark", 89 ],
            [ "Chevrolet Spark", 100 ],
            [ "Audi A8", 75 ],
            [ "Audi A8", 75 ],
            [ "Audi A8", 84 ],
            [ "Audi TT", 39 ],
            [ "Audi TT", 39 ],
            [ "Audi TT", 44 ],
            [ "Audi R8", 22 ],
            [ "Audi R8", 22 ],
            [ "Audi R8", 24 ],
            [ "Acura NSX", 0 ],
            [ "Acura NSX", 21 ],
            [ "Acura NSX", 25 ],
        ]; break;
        
        // S&P 500 as of January 1st (2023 estimated) (https://www.multpl.com/s-p-500-historical-prices/table/by-year).
        case "Stocks": data = [
            [ 1871, 4.44 ],
            [ 1872, 4.86 ],
            [ 1873, 5.11 ],
            [ 1874, 4.66 ],
            [ 1875, 4.54 ],
            [ 1876, 4.46 ],
            [ 1877, 3.55 ],
            [ 1878, 3.25 ],
            [ 1879, 3.58 ],
            [ 1880, 5.11 ],
            [ 1881, 6.19 ],
            [ 1882, 5.92 ],
            [ 1883, 5.81 ],
            [ 1884, 5.18 ],
            [ 1885, 4.24 ],
            [ 1886, 5.20 ],
            [ 1887, 5.58 ],
            [ 1888, 5.31 ],
            [ 1889, 5.24 ],
            [ 1890, 5.38 ],
            [ 1891, 4.84 ],
            [ 1892, 5.51 ],
            [ 1893, 5.61 ],
            [ 1894, 4.32 ],
            [ 1895, 4.25 ],
            [ 1896, 4.27 ],
            [ 1897, 4.22 ],
            [ 1898, 4.88 ],
            [ 1899, 6.08 ],
            [ 1900, 6.10 ],
            [ 1901, 7.07 ],
            [ 1902, 8.12 ],
            [ 1903, 8.46 ],
            [ 1904, 6.68 ],
            [ 1905, 8.43 ],
            [ 1906, 9.87 ],
            [ 1907, 9.56 ],
            [ 1908, 6.85 ],
            [ 1909, 9.06 ],
            [ 1910, 10.08 ],
            [ 1911, 9.27 ],
            [ 1912, 9.12 ],
            [ 1913, 9.30 ],
            [ 1914, 8.37 ],
            [ 1915, 7.48 ],
            [ 1916, 9.33 ],
            [ 1917, 9.57 ],
            [ 1918, 7.21 ],
            [ 1919, 7.85 ],
            [ 1920, 8.83 ],
            [ 1921, 7.11 ],
            [ 1922, 7.30 ],
            [ 1923, 8.90 ],
            [ 1924, 8.83 ],
            [ 1925, 10.58 ],
            [ 1926, 12.65 ],
            [ 1927, 13.40 ],
            [ 1928, 17.53 ],
            [ 1929, 24.86 ],
            [ 1930, 21.71 ],
            [ 1931, 15.98 ],
            [ 1932, 8.30 ],
            [ 1933, 7.09 ],
            [ 1934, 10.54 ],
            [ 1935, 9.26 ],
            [ 1936, 13.76 ],
            [ 1937, 17.59 ],
            [ 1938, 11.31 ],
            [ 1939, 12.50 ],
            [ 1940, 12.30 ],
            [ 1941, 10.55 ],
            [ 1942, 8.93 ],
            [ 1943, 10.09 ],
            [ 1944, 11.85 ],
            [ 1945, 13.49 ],
            [ 1946, 18.02 ],
            [ 1947, 15.21 ],
            [ 1948, 14.83 ],
            [ 1949, 15.36 ],
            [ 1950, 16.88 ],
            [ 1951, 21.21 ],
            [ 1952, 24.19 ],
            [ 1953, 26.18 ],
            [ 1954, 25.46 ],
            [ 1955, 35.60 ],
            [ 1956, 44.15 ],
            [ 1957, 45.43 ],
            [ 1958, 41.12 ],
            [ 1959, 55.62 ],
            [ 1960, 58.03 ],
            [ 1961, 59.72 ],
            [ 1962, 69.07 ],
            [ 1963, 65.06 ],
            [ 1964, 76.45 ],
            [ 1965, 86.12 ],
            [ 1966, 93.32 ],
            [ 1967, 84.45 ],
            [ 1968, 95.04 ],
            [ 1969, 102.00 ],
            [ 1970, 90.31 ],
            [ 1971, 93.49 ],
            [ 1972, 103.30 ],
            [ 1973, 118.40 ],
            [ 1974, 96.11 ],
            [ 1975, 72.56 ],
            [ 1976, 96.86 ],
            [ 1977, 103.80 ],
            [ 1978, 90.25 ],
            [ 1979, 99.71 ],
            [ 1980, 110.90 ],
            [ 1981, 133.00 ],
            [ 1982, 117.30 ],
            [ 1983, 144.30 ],
            [ 1984, 166.40 ],
            [ 1985, 171.60 ],
            [ 1986, 208.20 ],
            [ 1987, 264.50 ],
            [ 1988, 250.50 ],
            [ 1989, 285.40 ],
            [ 1990, 339.97 ],
            [ 1991, 325.49 ],
            [ 1992, 416.08 ],
            [ 1993, 435.23 ],
            [ 1994, 472.99 ],
            [ 1995, 465.25 ],
            [ 1996, 614.42 ],
            [ 1997, 766.22 ],
            [ 1998, 963.36 ],
            [ 1999, 1248.77 ],
            [ 2000, 1425.59 ],
            [ 2001, 1335.63 ],
            [ 2002, 1140.21 ],
            [ 2003, 895.84 ],
            [ 2004, 1132.52 ],
            [ 2005, 1181.41 ],
            [ 2006, 1278.73 ],
            [ 2007, 1424.16 ],
            [ 2008, 1378.76 ],
            [ 2009, 865.58 ],
            [ 2010, 1123.58 ],
            [ 2011, 1282.62 ],
            [ 2012, 1300.58 ],
            [ 2013, 1480.40 ],
            [ 2014, 1822.36 ],
            [ 2015, 2028.18 ],
            [ 2016, 1918.60 ],
            [ 2017, 2275.12 ],
            [ 2018, 2789.80 ],
            [ 2019, 2607.39 ],
            [ 2020, 3278.20 ],
            [ 2021, 3793.75 ],
            [ 2022, 4573.82 ],
            [ 2023, 4000 ],
        ]; break;
        
        // Subset of Google Trends 2020 (https://observablehq.com/@observablehq/plot-test-data/).
        case "Trends": data = [
            [ 1, "2019-12-29", "COVID-19", 0.5 ],
            [ 2, "2020-01-05", "COVID-19", 0.5 ],
            [ 3, "2020-01-12", "COVID-19", 0.5 ],
            [ 4, "2020-01-19", "COVID-19", 1 ],
            [ 5, "2020-01-26", "COVID-19", 1 ],
            [ 6, "2020-02-02", "COVID-19", 1 ],
            [ 7, "2020-02-09", "COVID-19", 1 ],
            [ 8, "2020-02-16", "COVID-19", 1 ],
            [ 9, "2020-02-23", "COVID-19", 4 ],
            [ 10, "2020-03-01", "COVID-19", 10 ],
            [ 11, "2020-03-08", "COVID-19", 38 ],
            [ 12, "2020-03-15", "COVID-19", 87 ],
            [ 13, "2020-03-22", "COVID-19", 97 ],
            [ 14, "2020-03-29", "COVID-19", 100 ],
            [ 15, "2020-04-05", "COVID-19", 86 ],
            [ 16, "2020-04-12", "COVID-19", 67 ],
            [ 17, "2020-04-19", "COVID-19", 61 ],
            [ 18, "2020-04-26", "COVID-19", 55 ],
            [ 19, "2020-05-03", "COVID-19", 51 ],
            [ 20, "2020-05-10", "COVID-19", 50 ],
            [ 21, "2020-05-17", "COVID-19", 48 ],
            [ 22, "2020-05-24", "COVID-19", 42 ],
            [ 23, "2020-05-31", "COVID-19", 35 ],
            [ 24, "2020-06-07", "COVID-19", 39 ],
            [ 25, "2020-06-14", "COVID-19", 47 ],
            [ 26, "2020-06-21", "COVID-19", 59 ],
            [ 27, "2020-06-28", "COVID-19", 65 ],
            [ 28, "2020-07-05", "COVID-19", 66 ],
            [ 29, "2020-07-12", "COVID-19", 70 ],
            [ 30, "2020-07-19", "COVID-19", 61 ],
            [ 31, "2020-07-26", "COVID-19", 59 ],
            [ 32, "2020-08-02", "COVID-19", 61 ],
            [ 33, "2020-08-09", "COVID-19", 48 ],
            [ 34, "2020-08-16", "COVID-19", 42 ],
            [ 35, "2020-08-23", "COVID-19", 38 ],
            [ 36, "2020-08-30", "COVID-19", 40 ],
            [ 37, "2020-09-06", "COVID-19", 36 ],
            [ 38, "2020-09-13", "COVID-19", 33 ],
            [ 39, "2020-09-20", "COVID-19", 35 ],
            [ 40, "2020-09-27", "COVID-19", 46 ],
            [ 41, "2020-10-04", "COVID-19", 44 ],
            [ 42, "2020-10-11", "COVID-19", 39 ],
            [ 43, "2020-10-18", "COVID-19", 42 ],
            [ 44, "2020-10-25", "COVID-19", 47 ],
            [ 45, "2020-11-01", "COVID-19", 38 ],
            [ 46, "2020-11-08", "COVID-19", 62 ],
            [ 47, "2020-11-15", "COVID-19", 79 ],
            [ 48, "2020-11-22", "COVID-19", 61 ],
            [ 49, "2020-11-29", "COVID-19", 61 ],
            [ 50, "2020-12-06", "COVID-19", 66 ],
            [ 51, "2020-12-13", "COVID-19", 65 ],
            [ 52, "2020-12-20", "COVID-19", 66 ],
            [ 53, "2020-12-27", "COVID-19", 66 ],
            [ 1, "2019-12-29", "TikTok", 29 ],
            [ 2, "2020-01-05", "TikTok", 29 ],
            [ 3, "2020-01-12", "TikTok", 29 ],
            [ 4, "2020-01-19", "TikTok", 33 ],
            [ 5, "2020-01-26", "TikTok", 27 ],
            [ 6, "2020-02-02", "TikTok", 28 ],
            [ 7, "2020-02-09", "TikTok", 32 ],
            [ 8, "2020-02-16", "TikTok", 34 ],
            [ 9, "2020-02-23", "TikTok", 33 ],
            [ 10, "2020-03-01", "TikTok", 33 ],
            [ 11, "2020-03-08", "TikTok", 35 ],
            [ 12, "2020-03-15", "TikTok", 43 ],
            [ 13, "2020-03-22", "TikTok", 55 ],
            [ 14, "2020-03-29", "TikTok", 55 ],
            [ 15, "2020-04-05", "TikTok", 56 ],
            [ 16, "2020-04-12", "TikTok", 57 ],
            [ 17, "2020-04-19", "TikTok", 57 ],
            [ 18, "2020-04-26", "TikTok", 55 ],
            [ 19, "2020-05-03", "TikTok", 51 ],
            [ 20, "2020-05-10", "TikTok", 49 ],
            [ 21, "2020-05-17", "TikTok", 53 ],
            [ 22, "2020-05-24", "TikTok", 49 ],
            [ 23, "2020-05-31", "TikTok", 43 ],
            [ 24, "2020-06-07", "TikTok", 43 ],
            [ 25, "2020-06-14", "TikTok", 46 ],
            [ 26, "2020-06-21", "TikTok", 54 ],
            [ 27, "2020-06-28", "TikTok", 51 ],
            [ 28, "2020-07-05", "TikTok", 100 ],
            [ 29, "2020-07-12", "TikTok", 55 ],
            [ 30, "2020-07-19", "TikTok", 48 ],
            [ 31, "2020-07-26", "TikTok", 86 ],
            [ 32, "2020-08-02", "TikTok", 84 ],
            [ 33, "2020-08-09", "TikTok", 52 ],
            [ 34, "2020-08-16", "TikTok", 48 ],
            [ 35, "2020-08-23", "TikTok", 50 ],
            [ 36, "2020-08-30", "TikTok", 52 ],
            [ 37, "2020-09-06", "TikTok", 63 ],
            [ 38, "2020-09-13", "TikTok", 78 ],
            [ 39, "2020-09-20", "TikTok", 69 ],
            [ 40, "2020-09-27", "TikTok", 46 ],
            [ 41, "2020-10-04", "TikTok", 48 ],
            [ 42, "2020-10-11", "TikTok", 44 ],
            [ 43, "2020-10-18", "TikTok", 44 ],
            [ 44, "2020-10-25", "TikTok", 44 ],
            [ 45, "2020-11-01", "TikTok", 37 ],
            [ 46, "2020-11-08", "TikTok", 44 ],
            [ 47, "2020-11-15", "TikTok", 50 ],
            [ 48, "2020-11-22", "TikTok", 49 ],
            [ 49, "2020-11-29", "TikTok", 49 ],
            [ 50, "2020-12-06", "TikTok", 47 ],
            [ 51, "2020-12-13", "TikTok", 48 ],
            [ 52, "2020-12-20", "TikTok", 48 ],
            [ 53, "2020-12-27", "TikTok", 49 ],
            [ 1, "2019-12-29", "Masks", 7 ],
            [ 2, "2020-01-05", "Masks", 7 ],
            [ 3, "2020-01-12", "Masks", 7 ],
            [ 4, "2020-01-19", "Masks", 9 ],
            [ 5, "2020-01-26", "Masks", 15 ],
            [ 6, "2020-02-02", "Masks", 11 ],
            [ 7, "2020-02-09", "Masks", 10 ],
            [ 8, "2020-02-16", "Masks", 9 ],
            [ 9, "2020-02-23", "Masks", 28 ],
            [ 10, "2020-03-01", "Masks", 21 ],
            [ 11, "2020-03-08", "Masks", 20 ],
            [ 12, "2020-03-15", "Masks", 33 ],
            [ 13, "2020-03-22", "Masks", 48 ],
            [ 14, "2020-03-29", "Masks", 98 ],
            [ 15, "2020-04-05", "Masks", 100 ],
            [ 16, "2020-04-12", "Masks", 72 ],
            [ 17, "2020-04-19", "Masks", 64 ],
            [ 18, "2020-04-26", "Masks", 61 ],
            [ 19, "2020-05-03", "Masks", 56 ],
            [ 20, "2020-05-10", "Masks", 53 ],
            [ 21, "2020-05-17", "Masks", 47 ],
            [ 22, "2020-05-24", "Masks", 44 ],
            [ 23, "2020-05-31", "Masks", 31 ],
            [ 24, "2020-06-07", "Masks", 31 ],
            [ 25, "2020-06-14", "Masks", 41 ],
            [ 26, "2020-06-21", "Masks", 54 ],
            [ 27, "2020-06-28", "Masks", 62 ],
            [ 28, "2020-07-05", "Masks", 57 ],
            [ 29, "2020-07-12", "Masks", 65 ],
            [ 30, "2020-07-19", "Masks", 60 ],
            [ 31, "2020-07-26", "Masks", 49 ],
            [ 32, "2020-08-02", "Masks", 43 ],
            [ 33, "2020-08-09", "Masks", 42 ],
            [ 34, "2020-08-16", "Masks", 35 ],
            [ 35, "2020-08-23", "Masks", 31 ],
            [ 36, "2020-08-30", "Masks", 29 ],
            [ 37, "2020-09-06", "Masks", 28 ],
            [ 38, "2020-09-13", "Masks", 28 ],
            [ 39, "2020-09-20", "Masks", 27 ],
            [ 40, "2020-09-27", "Masks", 27 ],
            [ 41, "2020-10-04", "Masks", 27 ],
            [ 42, "2020-10-11", "Masks", 26 ],
            [ 43, "2020-10-18", "Masks", 26 ],
            [ 44, "2020-10-25", "Masks", 28 ],
            [ 45, "2020-11-01", "Masks", 18 ],
            [ 46, "2020-11-08", "Masks", 24 ],
            [ 47, "2020-11-15", "Masks", 27 ],
            [ 48, "2020-11-22", "Masks", 23 ],
            [ 49, "2020-11-29", "Masks", 22 ],
            [ 50, "2020-12-06", "Masks", 21 ],
            [ 51, "2020-12-13", "Masks", 19 ],
            [ 52, "2020-12-20", "Masks", 17 ],
            [ 53, "2020-12-27", "Masks", 18 ],
            [ 1, "2019-12-29", "Zoom Video", 1 ],
            [ 2, "2020-01-05", "Zoom Video", 2 ],
            [ 3, "2020-01-12", "Zoom Video", 2 ],
            [ 4, "2020-01-19", "Zoom Video", 2 ],
            [ 5, "2020-01-26", "Zoom Video", 2 ],
            [ 6, "2020-02-02", "Zoom Video", 2 ],
            [ 7, "2020-02-09", "Zoom Video", 2 ],
            [ 8, "2020-02-16", "Zoom Video", 2 ],
            [ 9, "2020-02-23", "Zoom Video", 2 ],
            [ 10, "2020-03-01", "Zoom Video", 3 ],
            [ 11, "2020-03-08", "Zoom Video", 10 ],
            [ 12, "2020-03-15", "Zoom Video", 43 ],
            [ 13, "2020-03-22", "Zoom Video", 85 ],
            [ 14, "2020-03-29", "Zoom Video", 100 ],
            [ 15, "2020-04-05", "Zoom Video", 80 ],
            [ 16, "2020-04-12", "Zoom Video", 68 ],
            [ 17, "2020-04-19", "Zoom Video", 61 ],
            [ 18, "2020-04-26", "Zoom Video", 55 ],
            [ 19, "2020-05-03", "Zoom Video", 46 ],
            [ 20, "2020-05-10", "Zoom Video", 44 ],
            [ 21, "2020-05-17", "Zoom Video", 37 ],
            [ 22, "2020-05-24", "Zoom Video", 30 ],
            [ 23, "2020-05-31", "Zoom Video", 30 ],
            [ 24, "2020-06-07", "Zoom Video", 26 ],
            [ 25, "2020-06-14", "Zoom Video", 23 ],
            [ 26, "2020-06-21", "Zoom Video", 21 ],
            [ 27, "2020-06-28", "Zoom Video", 18 ],
            [ 28, "2020-07-05", "Zoom Video", 20 ],
            [ 29, "2020-07-12", "Zoom Video", 21 ],
            [ 30, "2020-07-19", "Zoom Video", 21 ],
            [ 31, "2020-07-26", "Zoom Video", 21 ],
            [ 32, "2020-08-02", "Zoom Video", 24 ],
            [ 33, "2020-08-09", "Zoom Video", 33 ],
            [ 34, "2020-08-16", "Zoom Video", 46 ],
            [ 35, "2020-08-23", "Zoom Video", 51 ],
            [ 36, "2020-08-30", "Zoom Video", 50 ],
            [ 37, "2020-09-06", "Zoom Video", 47 ],
            [ 38, "2020-09-13", "Zoom Video", 46 ],
            [ 39, "2020-09-20", "Zoom Video", 40 ],
            [ 40, "2020-09-27", "Zoom Video", 32 ],
            [ 41, "2020-10-04", "Zoom Video", 29 ],
            [ 42, "2020-10-11", "Zoom Video", 22 ],
            [ 43, "2020-10-18", "Zoom Video", 26 ],
            [ 44, "2020-10-25", "Zoom Video", 22 ],
            [ 45, "2020-11-01", "Zoom Video", 17 ],
            [ 46, "2020-11-08", "Zoom Video", 21 ],
            [ 47, "2020-11-15", "Zoom Video", 24 ],
            [ 48, "2020-11-22", "Zoom Video", 17 ],
            [ 49, "2020-11-29", "Zoom Video", 22 ],
            [ 50, "2020-12-06", "Zoom Video", 22 ],
            [ 51, "2020-12-13", "Zoom Video", 22 ],
            [ 52, "2020-12-20", "Zoom Video", 16 ],
            [ 53, "2020-12-27", "Zoom Video", 11 ],
            [ 1, "2019-12-29", "Anthony Fauci", 0.5 ],
            [ 2, "2020-01-05", "Anthony Fauci", 0.5 ],
            [ 3, "2020-01-12", "Anthony Fauci", 0.5 ],
            [ 4, "2020-01-19", "Anthony Fauci", 0.5 ],
            [ 5, "2020-01-26", "Anthony Fauci", 0.5 ],
            [ 6, "2020-02-02", "Anthony Fauci", 0.5 ],
            [ 7, "2020-02-09", "Anthony Fauci", 0.5 ],
            [ 8, "2020-02-16", "Anthony Fauci", 0.5 ],
            [ 9, "2020-02-23", "Anthony Fauci", 3 ],
            [ 10, "2020-03-01", "Anthony Fauci", 5 ],
            [ 11, "2020-03-08", "Anthony Fauci", 23 ],
            [ 12, "2020-03-15", "Anthony Fauci", 57 ],
            [ 13, "2020-03-22", "Anthony Fauci", 100 ],
            [ 14, "2020-03-29", "Anthony Fauci", 82 ],
            [ 15, "2020-04-05", "Anthony Fauci", 64 ],
            [ 16, "2020-04-12", "Anthony Fauci", 87 ],
            [ 17, "2020-04-19", "Anthony Fauci", 42 ],
            [ 18, "2020-04-26", "Anthony Fauci", 60 ],
            [ 19, "2020-05-03", "Anthony Fauci", 71 ],
            [ 20, "2020-05-10", "Anthony Fauci", 78 ],
            [ 21, "2020-05-17", "Anthony Fauci", 25 ],
            [ 22, "2020-05-24", "Anthony Fauci", 19 ],
            [ 23, "2020-05-31", "Anthony Fauci", 11 ],
            [ 24, "2020-06-07", "Anthony Fauci", 13 ],
            [ 25, "2020-06-14", "Anthony Fauci", 15 ],
            [ 26, "2020-06-21", "Anthony Fauci", 18 ],
            [ 27, "2020-06-28", "Anthony Fauci", 24 ],
            [ 28, "2020-07-05", "Anthony Fauci", 27 ],
            [ 29, "2020-07-12", "Anthony Fauci", 51 ],
            [ 30, "2020-07-19", "Anthony Fauci", 64 ],
            [ 31, "2020-07-26", "Anthony Fauci", 65 ],
            [ 32, "2020-08-02", "Anthony Fauci", 36 ],
            [ 33, "2020-08-09", "Anthony Fauci", 18 ],
            [ 34, "2020-08-16", "Anthony Fauci", 13 ],
            [ 35, "2020-08-23", "Anthony Fauci", 12 ],
            [ 36, "2020-08-30", "Anthony Fauci", 13 ],
            [ 37, "2020-09-06", "Anthony Fauci", 13 ],
            [ 38, "2020-09-13", "Anthony Fauci", 10 ],
            [ 39, "2020-09-20", "Anthony Fauci", 14 ],
            [ 40, "2020-09-27", "Anthony Fauci", 13 ],
            [ 41, "2020-10-04", "Anthony Fauci", 15 ],
            [ 42, "2020-10-11", "Anthony Fauci", 17 ],
            [ 43, "2020-10-18", "Anthony Fauci", 31 ],
            [ 44, "2020-10-25", "Anthony Fauci", 14 ],
            [ 45, "2020-11-01", "Anthony Fauci", 21 ],
            [ 46, "2020-11-08", "Anthony Fauci", 22 ],
            [ 47, "2020-11-15", "Anthony Fauci", 16 ],
            [ 48, "2020-11-22", "Anthony Fauci", 10 ],
            [ 49, "2020-11-29", "Anthony Fauci", 16 ],
            [ 50, "2020-12-06", "Anthony Fauci", 16 ],
            [ 51, "2020-12-13", "Anthony Fauci", 16 ],
            [ 52, "2020-12-20", "Anthony Fauci", 27 ],
            [ 53, "2020-12-27", "Anthony Fauci", 20 ],
            [ 1, "2019-12-29", "Taylor Swift", 25 ],
            [ 2, "2020-01-05", "Taylor Swift", 24 ],
            [ 3, "2020-01-12", "Taylor Swift", 19 ],
            [ 4, "2020-01-19", "Taylor Swift", 29 ],
            [ 5, "2020-01-26", "Taylor Swift", 41 ],
            [ 6, "2020-02-02", "Taylor Swift", 56 ],
            [ 7, "2020-02-09", "Taylor Swift", 30 ],
            [ 8, "2020-02-16", "Taylor Swift", 25 ],
            [ 9, "2020-02-23", "Taylor Swift", 33 ],
            [ 10, "2020-03-01", "Taylor Swift", 24 ],
            [ 11, "2020-03-08", "Taylor Swift", 18 ],
            [ 12, "2020-03-15", "Taylor Swift", 20 ],
            [ 13, "2020-03-22", "Taylor Swift", 33 ],
            [ 14, "2020-03-29", "Taylor Swift", 18 ],
            [ 15, "2020-04-05", "Taylor Swift", 17 ],
            [ 16, "2020-04-12", "Taylor Swift", 17 ],
            [ 17, "2020-04-19", "Taylor Swift", 25 ],
            [ 18, "2020-04-26", "Taylor Swift", 18 ],
            [ 19, "2020-05-03", "Taylor Swift", 17 ],
            [ 20, "2020-05-10", "Taylor Swift", 18 ],
            [ 21, "2020-05-17", "Taylor Swift", 31 ],
            [ 22, "2020-05-24", "Taylor Swift", 22 ],
            [ 23, "2020-05-31", "Taylor Swift", 16 ],
            [ 24, "2020-06-07", "Taylor Swift", 15 ],
            [ 25, "2020-06-14", "Taylor Swift", 15 ],
            [ 26, "2020-06-21", "Taylor Swift", 15 ],
            [ 27, "2020-06-28", "Taylor Swift", 15 ],
            [ 28, "2020-07-05", "Taylor Swift", 15 ],
            [ 29, "2020-07-12", "Taylor Swift", 14 ],
            [ 30, "2020-07-19", "Taylor Swift", 100 ],
            [ 31, "2020-07-26", "Taylor Swift", 79 ],
            [ 32, "2020-08-02", "Taylor Swift", 41 ],
            [ 33, "2020-08-09", "Taylor Swift", 29 ],
            [ 34, "2020-08-16", "Taylor Swift", 30 ],
            [ 35, "2020-08-23", "Taylor Swift", 24 ],
            [ 36, "2020-08-30", "Taylor Swift", 24 ],
            [ 37, "2020-09-06", "Taylor Swift", 21 ],
            [ 38, "2020-09-13", "Taylor Swift", 31 ],
            [ 39, "2020-09-20", "Taylor Swift", 21 ],
            [ 40, "2020-09-27", "Taylor Swift", 23 ],
            [ 41, "2020-10-04", "Taylor Swift", 19 ],
            [ 42, "2020-10-11", "Taylor Swift", 18 ],
            [ 43, "2020-10-18", "Taylor Swift", 18 ],
            [ 44, "2020-10-25", "Taylor Swift", 18 ],
            [ 45, "2020-11-01", "Taylor Swift", 14 ],
            [ 46, "2020-11-08", "Taylor Swift", 19 ],
            [ 47, "2020-11-15", "Taylor Swift", 23 ],
            [ 48, "2020-11-22", "Taylor Swift", 33 ],
            [ 49, "2020-11-29", "Taylor Swift", 26 ],
            [ 50, "2020-12-06", "Taylor Swift", 67 ],
            [ 51, "2020-12-13", "Taylor Swift", 56 ],
            [ 52, "2020-12-20", "Taylor Swift", 34 ],
            [ 53, "2020-12-27", "Taylor Swift", 34 ],
            [ 1, "2019-12-29", "Absentee ballot", 1 ],
            [ 2, "2020-01-05", "Absentee ballot", 1 ],
            [ 3, "2020-01-12", "Absentee ballot", 1 ],
            [ 4, "2020-01-19", "Absentee ballot", 1 ],
            [ 5, "2020-01-26", "Absentee ballot", 3 ],
            [ 6, "2020-02-02", "Absentee ballot", 5 ],
            [ 7, "2020-02-09", "Absentee ballot", 6 ],
            [ 8, "2020-02-16", "Absentee ballot", 8 ],
            [ 9, "2020-02-23", "Absentee ballot", 9 ],
            [ 10, "2020-03-01", "Absentee ballot", 14 ],
            [ 11, "2020-03-08", "Absentee ballot", 7 ],
            [ 12, "2020-03-15", "Absentee ballot", 12 ],
            [ 13, "2020-03-22", "Absentee ballot", 9 ],
            [ 14, "2020-03-29", "Absentee ballot", 12 ],
            [ 15, "2020-04-05", "Absentee ballot", 14 ],
            [ 16, "2020-04-12", "Absentee ballot", 8 ],
            [ 17, "2020-04-19", "Absentee ballot", 7 ],
            [ 18, "2020-04-26", "Absentee ballot", 7 ],
            [ 19, "2020-05-03", "Absentee ballot", 7 ],
            [ 20, "2020-05-10", "Absentee ballot", 10 ],
            [ 21, "2020-05-17", "Absentee ballot", 14 ],
            [ 22, "2020-05-24", "Absentee ballot", 15 ],
            [ 23, "2020-05-31", "Absentee ballot", 18 ],
            [ 24, "2020-06-07", "Absentee ballot", 15 ],
            [ 25, "2020-06-14", "Absentee ballot", 13 ],
            [ 26, "2020-06-21", "Absentee ballot", 16 ],
            [ 27, "2020-06-28", "Absentee ballot", 11 ],
            [ 28, "2020-07-05", "Absentee ballot", 10 ],
            [ 29, "2020-07-12", "Absentee ballot", 10 ],
            [ 30, "2020-07-19", "Absentee ballot", 13 ],
            [ 31, "2020-07-26", "Absentee ballot", 32 ],
            [ 32, "2020-08-02", "Absentee ballot", 36 ],
            [ 33, "2020-08-09", "Absentee ballot", 46 ],
            [ 34, "2020-08-16", "Absentee ballot", 71 ],
            [ 35, "2020-08-23", "Absentee ballot", 30 ],
            [ 36, "2020-08-30", "Absentee ballot", 32 ],
            [ 37, "2020-09-06", "Absentee ballot", 33 ],
            [ 38, "2020-09-13", "Absentee ballot", 41 ],
            [ 39, "2020-09-20", "Absentee ballot", 62 ],
            [ 40, "2020-09-27", "Absentee ballot", 69 ],
            [ 41, "2020-10-04", "Absentee ballot", 79 ],
            [ 42, "2020-10-11", "Absentee ballot", 78 ],
            [ 43, "2020-10-18", "Absentee ballot", 83 ],
            [ 44, "2020-10-25", "Absentee ballot", 87 ],
            [ 45, "2020-11-01", "Absentee ballot", 100 ],
            [ 46, "2020-11-08", "Absentee ballot", 12 ],
            [ 47, "2020-11-15", "Absentee ballot", 5 ],
            [ 48, "2020-11-22", "Absentee ballot", 6 ],
            [ 49, "2020-11-29", "Absentee ballot", 4 ],
            [ 50, "2020-12-06", "Absentee ballot", 4 ],
            [ 51, "2020-12-13", "Absentee ballot", 3 ],
            [ 52, "2020-12-20", "Absentee ballot", 2 ],
            [ 53, "2020-12-27", "Absentee ballot", 3 ],
            [ 1, "2019-12-29", "Stock market", 12 ],
            [ 2, "2020-01-05", "Stock market", 13 ],
            [ 3, "2020-01-12", "Stock market", 12 ],
            [ 4, "2020-01-19", "Stock market", 12 ],
            [ 5, "2020-01-26", "Stock market", 14 ],
            [ 6, "2020-02-02", "Stock market", 15 ],
            [ 7, "2020-02-09", "Stock market", 12 ],
            [ 8, "2020-02-16", "Stock market", 13 ],
            [ 9, "2020-02-23", "Stock market", 53 ],
            [ 10, "2020-03-01", "Stock market", 45 ],
            [ 11, "2020-03-08", "Stock market", 100 ],
            [ 12, "2020-03-15", "Stock market", 81 ],
            [ 13, "2020-03-22", "Stock market", 57 ],
            [ 14, "2020-03-29", "Stock market", 34 ],
            [ 15, "2020-04-05", "Stock market", 39 ],
            [ 16, "2020-04-12", "Stock market", 28 ],
            [ 17, "2020-04-19", "Stock market", 24 ],
            [ 18, "2020-04-26", "Stock market", 23 ],
            [ 19, "2020-05-03", "Stock market", 20 ],
            [ 20, "2020-05-10", "Stock market", 20 ],
            [ 21, "2020-05-17", "Stock market", 20 ],
            [ 22, "2020-05-24", "Stock market", 18 ],
            [ 23, "2020-05-31", "Stock market", 21 ],
            [ 24, "2020-06-07", "Stock market", 29 ],
            [ 25, "2020-06-14", "Stock market", 21 ],
            [ 26, "2020-06-21", "Stock market", 19 ],
            [ 27, "2020-06-28", "Stock market", 20 ],
            [ 28, "2020-07-05", "Stock market", 18 ],
            [ 29, "2020-07-12", "Stock market", 17 ],
            [ 30, "2020-07-19", "Stock market", 16 ],
            [ 31, "2020-07-26", "Stock market", 16 ],
            [ 32, "2020-08-02", "Stock market", 15 ],
            [ 33, "2020-08-09", "Stock market", 15 ],
            [ 34, "2020-08-16", "Stock market", 13 ],
            [ 35, "2020-08-23", "Stock market", 13 ],
            [ 36, "2020-08-30", "Stock market", 21 ],
            [ 37, "2020-09-06", "Stock market", 17 ],
            [ 38, "2020-09-13", "Stock market", 13 ],
            [ 39, "2020-09-20", "Stock market", 15 ],
            [ 40, "2020-09-27", "Stock market", 15 ],
            [ 41, "2020-10-04", "Stock market", 17 ],
            [ 42, "2020-10-11", "Stock market", 15 ],
            [ 43, "2020-10-18", "Stock market", 13 ],
            [ 44, "2020-10-25", "Stock market", 19 ],
            [ 45, "2020-11-01", "Stock market", 20 ],
            [ 46, "2020-11-08", "Stock market", 21 ],
            [ 47, "2020-11-15", "Stock market", 15 ],
            [ 48, "2020-11-22", "Stock market", 20 ],
            [ 49, "2020-11-29", "Stock market", 14 ],
            [ 50, "2020-12-06", "Stock market", 14 ],
            [ 51, "2020-12-13", "Stock market", 13 ],
            [ 52, "2020-12-20", "Stock market", 17 ],
            [ 53, "2020-12-27", "Stock market", 14 ],
            [ 1, "2019-12-29", "Prince Harry, Meghan", 8 ],
            [ 2, "2020-01-05", "Prince Harry, Meghan", 99 ],
            [ 3, "2020-01-12", "Prince Harry, Meghan", 100 ],
            [ 4, "2020-01-19", "Prince Harry, Meghan", 78 ],
            [ 5, "2020-01-26", "Prince Harry, Meghan", 31 ],
            [ 6, "2020-02-02", "Prince Harry, Meghan", 20 ],
            [ 7, "2020-02-09", "Prince Harry, Meghan", 16 ],
            [ 8, "2020-02-16", "Prince Harry, Meghan", 21 ],
            [ 9, "2020-02-23", "Prince Harry, Meghan", 24 ],
            [ 10, "2020-03-01", "Prince Harry, Meghan", 22 ],
            [ 11, "2020-03-08", "Prince Harry, Meghan", 31 ],
            [ 12, "2020-03-15", "Prince Harry, Meghan", 13 ],
            [ 13, "2020-03-22", "Prince Harry, Meghan", 15 ],
            [ 14, "2020-03-29", "Prince Harry, Meghan", 20 ],
            [ 15, "2020-04-05", "Prince Harry, Meghan", 14 ],
            [ 16, "2020-04-12", "Prince Harry, Meghan", 14 ],
            [ 17, "2020-04-19", "Prince Harry, Meghan", 14 ],
            [ 18, "2020-04-26", "Prince Harry, Meghan", 11 ],
            [ 19, "2020-05-03", "Prince Harry, Meghan", 12 ],
            [ 20, "2020-05-10", "Prince Harry, Meghan", 11 ],
            [ 21, "2020-05-17", "Prince Harry, Meghan", 9 ],
            [ 22, "2020-05-24", "Prince Harry, Meghan", 9 ],
            [ 23, "2020-05-31", "Prince Harry, Meghan", 8 ],
            [ 24, "2020-06-07", "Prince Harry, Meghan", 8 ],
            [ 25, "2020-06-14", "Prince Harry, Meghan", 7 ],
            [ 26, "2020-06-21", "Prince Harry, Meghan", 8 ],
            [ 27, "2020-06-28", "Prince Harry, Meghan", 6 ],
            [ 28, "2020-07-05", "Prince Harry, Meghan", 9 ],
            [ 29, "2020-07-12", "Prince Harry, Meghan", 8 ],
            [ 30, "2020-07-19", "Prince Harry, Meghan", 11 ],
            [ 31, "2020-07-26", "Prince Harry, Meghan", 15 ],
            [ 32, "2020-08-02", "Prince Harry, Meghan", 10 ],
            [ 33, "2020-08-09", "Prince Harry, Meghan", 13 ],
            [ 34, "2020-08-16", "Prince Harry, Meghan", 10 ],
            [ 35, "2020-08-23", "Prince Harry, Meghan", 6 ],
            [ 36, "2020-08-30", "Prince Harry, Meghan", 9 ],
            [ 37, "2020-09-06", "Prince Harry, Meghan", 11 ],
            [ 38, "2020-09-13", "Prince Harry, Meghan", 6 ],
            [ 39, "2020-09-20", "Prince Harry, Meghan", 8 ],
            [ 40, "2020-09-27", "Prince Harry, Meghan", 7 ],
            [ 41, "2020-10-04", "Prince Harry, Meghan", 7 ],
            [ 42, "2020-10-11", "Prince Harry, Meghan", 7 ],
            [ 43, "2020-10-18", "Prince Harry, Meghan", 6 ],
            [ 44, "2020-10-25", "Prince Harry, Meghan", 5 ],
            [ 45, "2020-11-01", "Prince Harry, Meghan", 4 ],
            [ 46, "2020-11-08", "Prince Harry, Meghan", 5 ],
            [ 47, "2020-11-15", "Prince Harry, Meghan", 8 ],
            [ 48, "2020-11-22", "Prince Harry, Meghan", 12 ],
            [ 49, "2020-11-29", "Prince Harry, Meghan", 7 ],
            [ 50, "2020-12-06", "Prince Harry, Meghan", 6 ],
            [ 51, "2020-12-13", "Prince Harry, Meghan", 8 ],
            [ 52, "2020-12-20", "Prince Harry, Meghan", 11 ],
            [ 53, "2020-12-27", "Prince Harry, Meghan", 10 ],
            [ 1, "2019-12-29", "Stimulus check", 0.5 ],
            [ 2, "2020-01-05", "Stimulus check", 0 ],
            [ 3, "2020-01-12", "Stimulus check", 0.5 ],
            [ 4, "2020-01-19", "Stimulus check", 0.5 ],
            [ 5, "2020-01-26", "Stimulus check", 0.5 ],
            [ 6, "2020-02-02", "Stimulus check", 0.5 ],
            [ 7, "2020-02-09", "Stimulus check", 0.5 ],
            [ 8, "2020-02-16", "Stimulus check", 0.5 ],
            [ 9, "2020-02-23", "Stimulus check", 0.5 ],
            [ 10, "2020-03-01", "Stimulus check", 0.5 ],
            [ 11, "2020-03-08", "Stimulus check", 0.5 ],
            [ 12, "2020-03-15", "Stimulus check", 10 ],
            [ 13, "2020-03-22", "Stimulus check", 21 ],
            [ 14, "2020-03-29", "Stimulus check", 16 ],
            [ 15, "2020-04-05", "Stimulus check", 22 ],
            [ 16, "2020-04-12", "Stimulus check", 100 ],
            [ 17, "2020-04-19", "Stimulus check", 46 ],
            [ 18, "2020-04-26", "Stimulus check", 37 ],
            [ 19, "2020-05-03", "Stimulus check", 32 ],
            [ 20, "2020-05-10", "Stimulus check", 35 ],
            [ 21, "2020-05-17", "Stimulus check", 31 ],
            [ 22, "2020-05-24", "Stimulus check", 21 ],
            [ 23, "2020-05-31", "Stimulus check", 17 ],
            [ 24, "2020-06-07", "Stimulus check", 14 ],
            [ 25, "2020-06-14", "Stimulus check", 10 ],
            [ 26, "2020-06-21", "Stimulus check", 16 ],
            [ 27, "2020-06-28", "Stimulus check", 14 ],
            [ 28, "2020-07-05", "Stimulus check", 14 ],
            [ 29, "2020-07-12", "Stimulus check", 12 ],
            [ 30, "2020-07-19", "Stimulus check", 19 ],
            [ 31, "2020-07-26", "Stimulus check", 25 ],
            [ 32, "2020-08-02", "Stimulus check", 22 ],
            [ 33, "2020-08-09", "Stimulus check", 16 ],
            [ 34, "2020-08-16", "Stimulus check", 11 ],
            [ 35, "2020-08-23", "Stimulus check", 10 ],
            [ 36, "2020-08-30", "Stimulus check", 10 ],
            [ 37, "2020-09-06", "Stimulus check", 12 ],
            [ 38, "2020-09-13", "Stimulus check", 11 ],
            [ 39, "2020-09-20", "Stimulus check", 11 ],
            [ 40, "2020-09-27", "Stimulus check", 15 ],
            [ 41, "2020-10-04", "Stimulus check", 14 ],
            [ 42, "2020-10-11", "Stimulus check", 11 ],
            [ 43, "2020-10-18", "Stimulus check", 13 ],
            [ 44, "2020-10-25", "Stimulus check", 9 ],
            [ 45, "2020-11-01", "Stimulus check", 5 ],
            [ 46, "2020-11-08", "Stimulus check", 7 ],
            [ 47, "2020-11-15", "Stimulus check", 7 ],
            [ 48, "2020-11-22", "Stimulus check", 6 ],
            [ 49, "2020-11-29", "Stimulus check", 7 ],
            [ 50, "2020-12-06", "Stimulus check", 7 ],
            [ 51, "2020-12-13", "Stimulus check", 14 ],
            [ 52, "2020-12-20", "Stimulus check", 46 ],
            [ 53, "2020-12-27", "Stimulus check", 56 ],
            [ 1, "2019-12-29", "Wuhan", 1 ],
            [ 2, "2020-01-05", "Wuhan", 2 ],
            [ 3, "2020-01-12", "Wuhan", 2 ],
            [ 4, "2020-01-19", "Wuhan", 61 ],
            [ 5, "2020-01-26", "Wuhan", 100 ],
            [ 6, "2020-02-02", "Wuhan", 53 ],
            [ 7, "2020-02-09", "Wuhan", 38 ],
            [ 8, "2020-02-16", "Wuhan", 25 ],
            [ 9, "2020-02-23", "Wuhan", 26 ],
            [ 10, "2020-03-01", "Wuhan", 31 ],
            [ 11, "2020-03-08", "Wuhan", 55 ],
            [ 12, "2020-03-15", "Wuhan", 72 ],
            [ 13, "2020-03-22", "Wuhan", 48 ],
            [ 14, "2020-03-29", "Wuhan", 37 ],
            [ 15, "2020-04-05", "Wuhan", 35 ],
            [ 16, "2020-04-12", "Wuhan", 38 ],
            [ 17, "2020-04-19", "Wuhan", 24 ],
            [ 18, "2020-04-26", "Wuhan", 19 ],
            [ 19, "2020-05-03", "Wuhan", 18 ],
            [ 20, "2020-05-10", "Wuhan", 15 ],
            [ 21, "2020-05-17", "Wuhan", 8 ],
            [ 22, "2020-05-24", "Wuhan", 6 ],
            [ 23, "2020-05-31", "Wuhan", 3 ],
            [ 24, "2020-06-07", "Wuhan", 4 ],
            [ 25, "2020-06-14", "Wuhan", 4 ],
            [ 26, "2020-06-21", "Wuhan", 3 ],
            [ 27, "2020-06-28", "Wuhan", 5 ],
            [ 28, "2020-07-05", "Wuhan", 5 ],
            [ 29, "2020-07-12", "Wuhan", 6 ],
            [ 30, "2020-07-19", "Wuhan", 5 ],
            [ 31, "2020-07-26", "Wuhan", 4 ],
            [ 32, "2020-08-02", "Wuhan", 7 ],
            [ 33, "2020-08-09", "Wuhan", 3 ],
            [ 34, "2020-08-16", "Wuhan", 9 ],
            [ 35, "2020-08-23", "Wuhan", 4 ],
            [ 36, "2020-08-30", "Wuhan", 3 ],
            [ 37, "2020-09-06", "Wuhan", 3 ],
            [ 38, "2020-09-13", "Wuhan", 4 ],
            [ 39, "2020-09-20", "Wuhan", 3 ],
            [ 40, "2020-09-27", "Wuhan", 2 ],
            [ 41, "2020-10-04", "Wuhan", 2 ],
            [ 42, "2020-10-11", "Wuhan", 2 ],
            [ 43, "2020-10-18", "Wuhan", 2 ],
            [ 44, "2020-10-25", "Wuhan", 2 ],
            [ 45, "2020-11-01", "Wuhan", 2 ],
            [ 46, "2020-11-08", "Wuhan", 2 ],
            [ 47, "2020-11-15", "Wuhan", 3 ],
            [ 48, "2020-11-22", "Wuhan", 2 ],
            [ 49, "2020-11-29", "Wuhan", 3 ],
            [ 50, "2020-12-06", "Wuhan", 3 ],
            [ 51, "2020-12-13", "Wuhan", 3 ],
            [ 52, "2020-12-20", "Wuhan", 3 ],
            [ 53, "2020-12-27", "Wuhan", 4 ],
            [ 1, "2019-12-29", "Hydroxychloroquine", 1 ],
            [ 2, "2020-01-05", "Hydroxychloroquine", 1 ],
            [ 3, "2020-01-12", "Hydroxychloroquine", 2 ],
            [ 4, "2020-01-19", "Hydroxychloroquine", 2 ],
            [ 5, "2020-01-26", "Hydroxychloroquine", 1 ],
            [ 6, "2020-02-02", "Hydroxychloroquine", 2 ],
            [ 7, "2020-02-09", "Hydroxychloroquine", 2 ],
            [ 8, "2020-02-16", "Hydroxychloroquine", 2 ],
            [ 9, "2020-02-23", "Hydroxychloroquine", 2 ],
            [ 10, "2020-03-01", "Hydroxychloroquine", 2 ],
            [ 11, "2020-03-08", "Hydroxychloroquine", 4 ],
            [ 12, "2020-03-15", "Hydroxychloroquine", 59 ],
            [ 13, "2020-03-22", "Hydroxychloroquine", 65 ],
            [ 14, "2020-03-29", "Hydroxychloroquine", 49 ],
            [ 15, "2020-04-05", "Hydroxychloroquine", 83 ],
            [ 16, "2020-04-12", "Hydroxychloroquine", 25 ],
            [ 17, "2020-04-19", "Hydroxychloroquine", 26 ],
            [ 18, "2020-04-26", "Hydroxychloroquine", 11 ],
            [ 19, "2020-05-03", "Hydroxychloroquine", 13 ],
            [ 20, "2020-05-10", "Hydroxychloroquine", 11 ],
            [ 21, "2020-05-17", "Hydroxychloroquine", 57 ],
            [ 22, "2020-05-24", "Hydroxychloroquine", 13 ],
            [ 23, "2020-05-31", "Hydroxychloroquine", 8 ],
            [ 24, "2020-06-07", "Hydroxychloroquine", 5 ],
            [ 25, "2020-06-14", "Hydroxychloroquine", 8 ],
            [ 26, "2020-06-21", "Hydroxychloroquine", 5 ],
            [ 27, "2020-06-28", "Hydroxychloroquine", 12 ],
            [ 28, "2020-07-05", "Hydroxychloroquine", 13 ],
            [ 29, "2020-07-12", "Hydroxychloroquine", 7 ],
            [ 30, "2020-07-19", "Hydroxychloroquine", 7 ],
            [ 31, "2020-07-26", "Hydroxychloroquine", 100 ],
            [ 32, "2020-08-02", "Hydroxychloroquine", 29 ],
            [ 33, "2020-08-09", "Hydroxychloroquine", 12 ],
            [ 34, "2020-08-16", "Hydroxychloroquine", 8 ],
            [ 35, "2020-08-23", "Hydroxychloroquine", 8 ],
            [ 36, "2020-08-30", "Hydroxychloroquine", 5 ],
            [ 37, "2020-09-06", "Hydroxychloroquine", 4 ],
            [ 38, "2020-09-13", "Hydroxychloroquine", 4 ],
            [ 39, "2020-09-20", "Hydroxychloroquine", 4 ],
            [ 40, "2020-09-27", "Hydroxychloroquine", 8 ],
            [ 41, "2020-10-04", "Hydroxychloroquine", 5 ],
            [ 42, "2020-10-11", "Hydroxychloroquine", 3 ],
            [ 43, "2020-10-18", "Hydroxychloroquine", 3 ],
            [ 44, "2020-10-25", "Hydroxychloroquine", 3 ],
            [ 45, "2020-11-01", "Hydroxychloroquine", 2 ],
            [ 46, "2020-11-08", "Hydroxychloroquine", 3 ],
            [ 47, "2020-11-15", "Hydroxychloroquine", 4 ],
            [ 48, "2020-11-22", "Hydroxychloroquine", 3 ],
            [ 49, "2020-11-29", "Hydroxychloroquine", 4 ],
            [ 50, "2020-12-06", "Hydroxychloroquine", 4 ],
            [ 51, "2020-12-13", "Hydroxychloroquine", 5 ],
            [ 52, "2020-12-20", "Hydroxychloroquine", 4 ],
            [ 53, "2020-12-27", "Hydroxychloroquine", 4 ],
            [ 1, "2019-12-29", "Brexit", 14 ],
            [ 2, "2020-01-05", "Brexit", 17 ],
            [ 3, "2020-01-12", "Brexit", 17 ],
            [ 4, "2020-01-19", "Brexit", 20 ],
            [ 5, "2020-01-26", "Brexit", 100 ],
            [ 6, "2020-02-02", "Brexit", 37 ],
            [ 7, "2020-02-09", "Brexit", 16 ],
            [ 8, "2020-02-16", "Brexit", 13 ],
            [ 9, "2020-02-23", "Brexit", 12 ],
            [ 10, "2020-03-01", "Brexit", 10 ],
            [ 11, "2020-03-08", "Brexit", 12 ],
            [ 12, "2020-03-15", "Brexit", 5 ],
            [ 13, "2020-03-22", "Brexit", 6 ],
            [ 14, "2020-03-29", "Brexit", 6 ],
            [ 15, "2020-04-05", "Brexit", 9 ],
            [ 16, "2020-04-12", "Brexit", 7 ],
            [ 17, "2020-04-19", "Brexit", 6 ],
            [ 18, "2020-04-26", "Brexit", 6 ],
            [ 19, "2020-05-03", "Brexit", 6 ],
            [ 20, "2020-05-10", "Brexit", 5 ],
            [ 21, "2020-05-17", "Brexit", 4 ],
            [ 22, "2020-05-24", "Brexit", 6 ],
            [ 23, "2020-05-31", "Brexit", 5 ],
            [ 24, "2020-06-07", "Brexit", 7 ],
            [ 25, "2020-06-14", "Brexit", 7 ],
            [ 26, "2020-06-21", "Brexit", 6 ],
            [ 27, "2020-06-28", "Brexit", 8 ],
            [ 28, "2020-07-05", "Brexit", 6 ],
            [ 29, "2020-07-12", "Brexit", 6 ],
            [ 30, "2020-07-19", "Brexit", 7 ],
            [ 31, "2020-07-26", "Brexit", 6 ],
            [ 32, "2020-08-02", "Brexit", 7 ],
            [ 33, "2020-08-09", "Brexit", 6 ],
            [ 34, "2020-08-16", "Brexit", 5 ],
            [ 35, "2020-08-23", "Brexit", 7 ],
            [ 36, "2020-08-30", "Brexit", 7 ],
            [ 37, "2020-09-06", "Brexit", 12 ],
            [ 38, "2020-09-13", "Brexit", 11 ],
            [ 39, "2020-09-20", "Brexit", 7 ],
            [ 40, "2020-09-27", "Brexit", 9 ],
            [ 41, "2020-10-04", "Brexit", 9 ],
            [ 42, "2020-10-11", "Brexit", 12 ],
            [ 43, "2020-10-18", "Brexit", 10 ],
            [ 44, "2020-10-25", "Brexit", 8 ],
            [ 45, "2020-11-01", "Brexit", 7 ],
            [ 46, "2020-11-08", "Brexit", 10 ],
            [ 47, "2020-11-15", "Brexit", 10 ],
            [ 48, "2020-11-22", "Brexit", 9 ],
            [ 49, "2020-11-29", "Brexit", 10 ],
            [ 50, "2020-12-06", "Brexit", 20 ],
            [ 51, "2020-12-13", "Brexit", 21 ],
            [ 52, "2020-12-20", "Brexit", 35 ],
            [ 53, "2020-12-27", "Brexit", 17 ],
            [ 1, "2019-12-29", "Joe Biden", 1 ],
            [ 2, "2020-01-05", "Joe Biden", 1 ],
            [ 3, "2020-01-12", "Joe Biden", 1 ],
            [ 4, "2020-01-19", "Joe Biden", 2 ],
            [ 5, "2020-01-26", "Joe Biden", 2 ],
            [ 6, "2020-02-02", "Joe Biden", 3 ],
            [ 7, "2020-02-09", "Joe Biden", 3 ],
            [ 8, "2020-02-16", "Joe Biden", 2 ],
            [ 9, "2020-02-23", "Joe Biden", 3 ],
            [ 10, "2020-03-01", "Joe Biden", 16 ],
            [ 11, "2020-03-08", "Joe Biden", 10 ],
            [ 12, "2020-03-15", "Joe Biden", 5 ],
            [ 13, "2020-03-22", "Joe Biden", 5 ],
            [ 14, "2020-03-29", "Joe Biden", 2 ],
            [ 15, "2020-04-05", "Joe Biden", 5 ],
            [ 16, "2020-04-12", "Joe Biden", 6 ],
            [ 17, "2020-04-19", "Joe Biden", 4 ],
            [ 18, "2020-04-26", "Joe Biden", 6 ],
            [ 19, "2020-05-03", "Joe Biden", 4 ],
            [ 20, "2020-05-10", "Joe Biden", 3 ],
            [ 21, "2020-05-17", "Joe Biden", 5 ],
            [ 22, "2020-05-24", "Joe Biden", 5 ],
            [ 23, "2020-05-31", "Joe Biden", 5 ],
            [ 24, "2020-06-07", "Joe Biden", 5 ],
            [ 25, "2020-06-14", "Joe Biden", 4 ],
            [ 26, "2020-06-21", "Joe Biden", 6 ],
            [ 27, "2020-06-28", "Joe Biden", 5 ],
            [ 28, "2020-07-05", "Joe Biden", 5 ],
            [ 29, "2020-07-12", "Joe Biden", 5 ],
            [ 30, "2020-07-19", "Joe Biden", 6 ],
            [ 31, "2020-07-26", "Joe Biden", 7 ],
            [ 32, "2020-08-02", "Joe Biden", 10 ],
            [ 33, "2020-08-09", "Joe Biden", 18 ],
            [ 34, "2020-08-16", "Joe Biden", 17 ],
            [ 35, "2020-08-23", "Joe Biden", 10 ],
            [ 36, "2020-08-30", "Joe Biden", 10 ],
            [ 37, "2020-09-06", "Joe Biden", 9 ],
            [ 38, "2020-09-13", "Joe Biden", 11 ],
            [ 39, "2020-09-20", "Joe Biden", 10 ],
            [ 40, "2020-09-27", "Joe Biden", 31 ],
            [ 41, "2020-10-04", "Joe Biden", 17 ],
            [ 42, "2020-10-11", "Joe Biden", 20 ],
            [ 43, "2020-10-18", "Joe Biden", 26 ],
            [ 44, "2020-10-25", "Joe Biden", 25 ],
            [ 45, "2020-11-01", "Joe Biden", 100 ],
            [ 46, "2020-11-08", "Joe Biden", 48 ],
            [ 47, "2020-11-15", "Joe Biden", 13 ],
            [ 48, "2020-11-22", "Joe Biden", 10 ],
            [ 49, "2020-11-29", "Joe Biden", 9 ],
            [ 50, "2020-12-06", "Joe Biden", 7 ],
            [ 51, "2020-12-13", "Joe Biden", 8 ],
            [ 52, "2020-12-20", "Joe Biden", 6 ],
            [ 53, "2020-12-27", "Joe Biden", 5 ],
            [ 1, "2019-12-29", "Toilet paper", 3 ],
            [ 2, "2020-01-05", "Toilet paper", 3 ],
            [ 3, "2020-01-12", "Toilet paper", 3 ],
            [ 4, "2020-01-19", "Toilet paper", 3 ],
            [ 5, "2020-01-26", "Toilet paper", 2 ],
            [ 6, "2020-02-02", "Toilet paper", 2 ],
            [ 7, "2020-02-09", "Toilet paper", 3 ],
            [ 8, "2020-02-16", "Toilet paper", 3 ],
            [ 9, "2020-02-23", "Toilet paper", 3 ],
            [ 10, "2020-03-01", "Toilet paper", 8 ],
            [ 11, "2020-03-08", "Toilet paper", 90 ],
            [ 12, "2020-03-15", "Toilet paper", 100 ],
            [ 13, "2020-03-22", "Toilet paper", 54 ],
            [ 14, "2020-03-29", "Toilet paper", 39 ],
            [ 15, "2020-04-05", "Toilet paper", 31 ],
            [ 16, "2020-04-12", "Toilet paper", 19 ],
            [ 17, "2020-04-19", "Toilet paper", 14 ],
            [ 18, "2020-04-26", "Toilet paper", 10 ],
            [ 19, "2020-05-03", "Toilet paper", 8 ],
            [ 20, "2020-05-10", "Toilet paper", 7 ],
            [ 21, "2020-05-17", "Toilet paper", 6 ],
            [ 22, "2020-05-24", "Toilet paper", 5 ],
            [ 23, "2020-05-31", "Toilet paper", 4 ],
            [ 24, "2020-06-07", "Toilet paper", 4 ],
            [ 25, "2020-06-14", "Toilet paper", 4 ],
            [ 26, "2020-06-21", "Toilet paper", 4 ],
            [ 27, "2020-06-28", "Toilet paper", 4 ],
            [ 28, "2020-07-05", "Toilet paper", 3 ],
            [ 29, "2020-07-12", "Toilet paper", 3 ],
            [ 30, "2020-07-19", "Toilet paper", 3 ],
            [ 31, "2020-07-26", "Toilet paper", 3 ],
            [ 32, "2020-08-02", "Toilet paper", 3 ],
            [ 33, "2020-08-09", "Toilet paper", 3 ],
            [ 34, "2020-08-16", "Toilet paper", 3 ],
            [ 35, "2020-08-23", "Toilet paper", 3 ],
            [ 36, "2020-08-30", "Toilet paper", 3 ],
            [ 37, "2020-09-06", "Toilet paper", 3 ],
            [ 38, "2020-09-13", "Toilet paper", 3 ],
            [ 39, "2020-09-20", "Toilet paper", 3 ],
            [ 40, "2020-09-27", "Toilet paper", 3 ],
            [ 41, "2020-10-04", "Toilet paper", 3 ],
            [ 42, "2020-10-11", "Toilet paper", 3 ],
            [ 43, "2020-10-18", "Toilet paper", 3 ],
            [ 44, "2020-10-25", "Toilet paper", 4 ],
            [ 45, "2020-11-01", "Toilet paper", 3 ],
            [ 46, "2020-11-08", "Toilet paper", 4 ],
            [ 47, "2020-11-15", "Toilet paper", 9 ],
            [ 48, "2020-11-22", "Toilet paper", 5 ],
            [ 49, "2020-11-29", "Toilet paper", 4 ],
            [ 50, "2020-12-06", "Toilet paper", 4 ],
            [ 51, "2020-12-13", "Toilet paper", 4 ],
            [ 52, "2020-12-20", "Toilet paper", 3 ],
            [ 53, "2020-12-27", "Toilet paper", 3 ],
            [ 1, "2019-12-29", "Impeachment", 22 ],
            [ 2, "2020-01-05", "Impeachment", 19 ],
            [ 3, "2020-01-12", "Impeachment", 40 ],
            [ 4, "2020-01-19", "Impeachment", 90 ],
            [ 5, "2020-01-26", "Impeachment", 100 ],
            [ 6, "2020-02-02", "Impeachment", 97 ],
            [ 7, "2020-02-09", "Impeachment", 11 ],
            [ 8, "2020-02-16", "Impeachment", 5 ],
            [ 9, "2020-02-23", "Impeachment", 4 ],
            [ 10, "2020-03-01", "Impeachment", 4 ],
            [ 11, "2020-03-08", "Impeachment", 3 ],
            [ 12, "2020-03-15", "Impeachment", 3 ],
            [ 13, "2020-03-22", "Impeachment", 3 ],
            [ 14, "2020-03-29", "Impeachment", 4 ],
            [ 15, "2020-04-05", "Impeachment", 3 ],
            [ 16, "2020-04-12", "Impeachment", 3 ],
            [ 17, "2020-04-19", "Impeachment", 3 ],
            [ 18, "2020-04-26", "Impeachment", 3 ],
            [ 19, "2020-05-03", "Impeachment", 3 ],
            [ 20, "2020-05-10", "Impeachment", 3 ],
            [ 21, "2020-05-17", "Impeachment", 3 ],
            [ 22, "2020-05-24", "Impeachment", 2 ],
            [ 23, "2020-05-31", "Impeachment", 3 ],
            [ 24, "2020-06-07", "Impeachment", 2 ],
            [ 25, "2020-06-14", "Impeachment", 2 ],
            [ 26, "2020-06-21", "Impeachment", 2 ],
            [ 27, "2020-06-28", "Impeachment", 2 ],
            [ 28, "2020-07-05", "Impeachment", 2 ],
            [ 29, "2020-07-12", "Impeachment", 2 ],
            [ 30, "2020-07-19", "Impeachment", 2 ],
            [ 31, "2020-07-26", "Impeachment", 2 ],
            [ 32, "2020-08-02", "Impeachment", 2 ],
            [ 33, "2020-08-09", "Impeachment", 2 ],
            [ 34, "2020-08-16", "Impeachment", 2 ],
            [ 35, "2020-08-23", "Impeachment", 3 ],
            [ 36, "2020-08-30", "Impeachment", 2 ],
            [ 37, "2020-09-06", "Impeachment", 2 ],
            [ 38, "2020-09-13", "Impeachment", 3 ],
            [ 39, "2020-09-20", "Impeachment", 6 ],
            [ 40, "2020-09-27", "Impeachment", 3 ],
            [ 41, "2020-10-04", "Impeachment", 3 ],
            [ 42, "2020-10-11", "Impeachment", 4 ],
            [ 43, "2020-10-18", "Impeachment", 3 ],
            [ 44, "2020-10-25", "Impeachment", 4 ],
            [ 45, "2020-11-01", "Impeachment", 5 ],
            [ 46, "2020-11-08", "Impeachment", 5 ],
            [ 47, "2020-11-15", "Impeachment", 4 ],
            [ 48, "2020-11-22", "Impeachment", 2 ],
            [ 49, "2020-11-29", "Impeachment", 3 ],
            [ 50, "2020-12-06", "Impeachment", 3 ],
            [ 51, "2020-12-13", "Impeachment", 3 ],
            [ 52, "2020-12-20", "Impeachment", 2 ],
            [ 53, "2020-12-27", "Impeachment", 1 ],
            [ 1, "2019-12-29", "Black Lives Matter", 0.5 ],
            [ 2, "2020-01-05", "Black Lives Matter", 0.5 ],
            [ 3, "2020-01-12", "Black Lives Matter", 0.5 ],
            [ 4, "2020-01-19", "Black Lives Matter", 1 ],
            [ 5, "2020-01-26", "Black Lives Matter", 0.5 ],
            [ 6, "2020-02-02", "Black Lives Matter", 2 ],
            [ 7, "2020-02-09", "Black Lives Matter", 1 ],
            [ 8, "2020-02-16", "Black Lives Matter", 1 ],
            [ 9, "2020-02-23", "Black Lives Matter", 1 ],
            [ 10, "2020-03-01", "Black Lives Matter", 0.5 ],
            [ 11, "2020-03-08", "Black Lives Matter", 0.5 ],
            [ 12, "2020-03-15", "Black Lives Matter", 0.5 ],
            [ 13, "2020-03-22", "Black Lives Matter", 0.5 ],
            [ 14, "2020-03-29", "Black Lives Matter", 0.5 ],
            [ 15, "2020-04-05", "Black Lives Matter", 0.5 ],
            [ 16, "2020-04-12", "Black Lives Matter", 0.5 ],
            [ 17, "2020-04-19", "Black Lives Matter", 0.5 ],
            [ 18, "2020-04-26", "Black Lives Matter", 0.5 ],
            [ 19, "2020-05-03", "Black Lives Matter", 1 ],
            [ 20, "2020-05-10", "Black Lives Matter", 1 ],
            [ 21, "2020-05-17", "Black Lives Matter", 1 ],
            [ 22, "2020-05-24", "Black Lives Matter", 14 ],
            [ 23, "2020-05-31", "Black Lives Matter", 100 ],
            [ 24, "2020-06-07", "Black Lives Matter", 55 ],
            [ 25, "2020-06-14", "Black Lives Matter", 35 ],
            [ 26, "2020-06-21", "Black Lives Matter", 26 ],
            [ 27, "2020-06-28", "Black Lives Matter", 23 ],
            [ 28, "2020-07-05", "Black Lives Matter", 22 ],
            [ 29, "2020-07-12", "Black Lives Matter", 16 ],
            [ 30, "2020-07-19", "Black Lives Matter", 15 ],
            [ 31, "2020-07-26", "Black Lives Matter", 14 ],
            [ 32, "2020-08-02", "Black Lives Matter", 10 ],
            [ 33, "2020-08-09", "Black Lives Matter", 10 ],
            [ 34, "2020-08-16", "Black Lives Matter", 9 ],
            [ 35, "2020-08-23", "Black Lives Matter", 13 ],
            [ 36, "2020-08-30", "Black Lives Matter", 12 ],
            [ 37, "2020-09-06", "Black Lives Matter", 10 ],
            [ 38, "2020-09-13", "Black Lives Matter", 10 ],
            [ 39, "2020-09-20", "Black Lives Matter", 9 ],
            [ 40, "2020-09-27", "Black Lives Matter", 7 ],
            [ 41, "2020-10-04", "Black Lives Matter", 5 ],
            [ 42, "2020-10-11", "Black Lives Matter", 4 ],
            [ 43, "2020-10-18", "Black Lives Matter", 4 ],
            [ 44, "2020-10-25", "Black Lives Matter", 4 ],
            [ 45, "2020-11-01", "Black Lives Matter", 4 ],
            [ 46, "2020-11-08", "Black Lives Matter", 3 ],
            [ 47, "2020-11-15", "Black Lives Matter", 3 ],
            [ 48, "2020-11-22", "Black Lives Matter", 2 ],
            [ 49, "2020-11-29", "Black Lives Matter", 2 ],
            [ 50, "2020-12-06", "Black Lives Matter", 2 ],
            [ 51, "2020-12-13", "Black Lives Matter", 2 ],
            [ 52, "2020-12-20", "Black Lives Matter", 2 ],
            [ 53, "2020-12-27", "Black Lives Matter", 2 ],
            [ 1, "2019-12-29", "Electoral fraud", 0.5 ],
            [ 2, "2020-01-05", "Electoral fraud", 0.5 ],
            [ 3, "2020-01-12", "Electoral fraud", 0.5 ],
            [ 4, "2020-01-19", "Electoral fraud", 0.5 ],
            [ 5, "2020-01-26", "Electoral fraud", 0.5 ],
            [ 6, "2020-02-02", "Electoral fraud", 1 ],
            [ 7, "2020-02-09", "Electoral fraud", 0.5 ],
            [ 8, "2020-02-16", "Electoral fraud", 1 ],
            [ 9, "2020-02-23", "Electoral fraud", 0.5 ],
            [ 10, "2020-03-01", "Electoral fraud", 1 ],
            [ 11, "2020-03-08", "Electoral fraud", 1 ],
            [ 12, "2020-03-15", "Electoral fraud", 1 ],
            [ 13, "2020-03-22", "Electoral fraud", 1 ],
            [ 14, "2020-03-29", "Electoral fraud", 0.5 ],
            [ 15, "2020-04-05", "Electoral fraud", 2 ],
            [ 16, "2020-04-12", "Electoral fraud", 2 ],
            [ 17, "2020-04-19", "Electoral fraud", 1 ],
            [ 18, "2020-04-26", "Electoral fraud", 1 ],
            [ 19, "2020-05-03", "Electoral fraud", 2 ],
            [ 20, "2020-05-10", "Electoral fraud", 2 ],
            [ 21, "2020-05-17", "Electoral fraud", 4 ],
            [ 22, "2020-05-24", "Electoral fraud", 6 ],
            [ 23, "2020-05-31", "Electoral fraud", 2 ],
            [ 24, "2020-06-07", "Electoral fraud", 2 ],
            [ 25, "2020-06-14", "Electoral fraud", 1 ],
            [ 26, "2020-06-21", "Electoral fraud", 3 ],
            [ 27, "2020-06-28", "Electoral fraud", 3 ],
            [ 28, "2020-07-05", "Electoral fraud", 3 ],
            [ 29, "2020-07-12", "Electoral fraud", 3 ],
            [ 30, "2020-07-19", "Electoral fraud", 1 ],
            [ 31, "2020-07-26", "Electoral fraud", 6 ],
            [ 32, "2020-08-02", "Electoral fraud", 6 ],
            [ 33, "2020-08-09", "Electoral fraud", 6 ],
            [ 34, "2020-08-16", "Electoral fraud", 7 ],
            [ 35, "2020-08-23", "Electoral fraud", 3 ],
            [ 36, "2020-08-30", "Electoral fraud", 4 ],
            [ 37, "2020-09-06", "Electoral fraud", 2 ],
            [ 38, "2020-09-13", "Electoral fraud", 2 ],
            [ 39, "2020-09-20", "Electoral fraud", 4 ],
            [ 40, "2020-09-27", "Electoral fraud", 6 ],
            [ 41, "2020-10-04", "Electoral fraud", 3 ],
            [ 42, "2020-10-11", "Electoral fraud", 3 ],
            [ 43, "2020-10-18", "Electoral fraud", 3 ],
            [ 44, "2020-10-25", "Electoral fraud", 6 ],
            [ 45, "2020-11-01", "Electoral fraud", 98 ],
            [ 46, "2020-11-08", "Electoral fraud", 100 ],
            [ 47, "2020-11-15", "Electoral fraud", 41 ],
            [ 48, "2020-11-22", "Electoral fraud", 19 ],
            [ 49, "2020-11-29", "Electoral fraud", 32 ],
            [ 50, "2020-12-06", "Electoral fraud", 23 ],
            [ 51, "2020-12-13", "Electoral fraud", 15 ],
            [ 52, "2020-12-20", "Electoral fraud", 11 ],
            [ 53, "2020-12-27", "Electoral fraud", 11 ],
            [ 1, "2019-12-29", "Kamala Harris", 0.5 ],
            [ 2, "2020-01-05", "Kamala Harris", 0.5 ],
            [ 3, "2020-01-12", "Kamala Harris", 1 ],
            [ 4, "2020-01-19", "Kamala Harris", 0.5 ],
            [ 5, "2020-01-26", "Kamala Harris", 0.5 ],
            [ 6, "2020-02-02", "Kamala Harris", 0.5 ],
            [ 7, "2020-02-09", "Kamala Harris", 0.5 ],
            [ 8, "2020-02-16", "Kamala Harris", 0.5 ],
            [ 9, "2020-02-23", "Kamala Harris", 0.5 ],
            [ 10, "2020-03-01", "Kamala Harris", 1 ],
            [ 11, "2020-03-08", "Kamala Harris", 1 ],
            [ 12, "2020-03-15", "Kamala Harris", 1 ],
            [ 13, "2020-03-22", "Kamala Harris", 0.5 ],
            [ 14, "2020-03-29", "Kamala Harris", 0.5 ],
            [ 15, "2020-04-05", "Kamala Harris", 1 ],
            [ 16, "2020-04-12", "Kamala Harris", 1 ],
            [ 17, "2020-04-19", "Kamala Harris", 0.5 ],
            [ 18, "2020-04-26", "Kamala Harris", 0.5 ],
            [ 19, "2020-05-03", "Kamala Harris", 0.5 ],
            [ 20, "2020-05-10", "Kamala Harris", 1 ],
            [ 21, "2020-05-17", "Kamala Harris", 0.5 ],
            [ 22, "2020-05-24", "Kamala Harris", 1 ],
            [ 23, "2020-05-31", "Kamala Harris", 1 ],
            [ 24, "2020-06-07", "Kamala Harris", 1 ],
            [ 25, "2020-06-14", "Kamala Harris", 1 ],
            [ 26, "2020-06-21", "Kamala Harris", 2 ],
            [ 27, "2020-06-28", "Kamala Harris", 1 ],
            [ 28, "2020-07-05", "Kamala Harris", 1 ],
            [ 29, "2020-07-12", "Kamala Harris", 1 ],
            [ 30, "2020-07-19", "Kamala Harris", 1 ],
            [ 31, "2020-07-26", "Kamala Harris", 3 ],
            [ 32, "2020-08-02", "Kamala Harris", 3 ],
            [ 33, "2020-08-09", "Kamala Harris", 100 ],
            [ 34, "2020-08-16", "Kamala Harris", 23 ],
            [ 35, "2020-08-23", "Kamala Harris", 7 ],
            [ 36, "2020-08-30", "Kamala Harris", 4 ],
            [ 37, "2020-09-06", "Kamala Harris", 4 ],
            [ 38, "2020-09-13", "Kamala Harris", 5 ],
            [ 39, "2020-09-20", "Kamala Harris", 4 ],
            [ 40, "2020-09-27", "Kamala Harris", 6 ],
            [ 41, "2020-10-04", "Kamala Harris", 25 ],
            [ 42, "2020-10-11", "Kamala Harris", 10 ],
            [ 43, "2020-10-18", "Kamala Harris", 7 ],
            [ 44, "2020-10-25", "Kamala Harris", 8 ],
            [ 45, "2020-11-01", "Kamala Harris", 27 ],
            [ 46, "2020-11-08", "Kamala Harris", 49 ],
            [ 47, "2020-11-15", "Kamala Harris", 5 ],
            [ 48, "2020-11-22", "Kamala Harris", 3 ],
            [ 49, "2020-11-29", "Kamala Harris", 3 ],
            [ 50, "2020-12-06", "Kamala Harris", 2 ],
            [ 51, "2020-12-13", "Kamala Harris", 2 ],
            [ 52, "2020-12-20", "Kamala Harris", 2 ],
            [ 53, "2020-12-27", "Kamala Harris", 2 ],
            [ 1, "2019-12-29", "Democratic primaries", 3 ],
            [ 2, "2020-01-05", "Democratic primaries", 3 ],
            [ 3, "2020-01-12", "Democratic primaries", 6 ],
            [ 4, "2020-01-19", "Democratic primaries", 4 ],
            [ 5, "2020-01-26", "Democratic primaries", 4 ],
            [ 6, "2020-02-02", "Democratic primaries", 12 ],
            [ 7, "2020-02-09", "Democratic primaries", 15 ],
            [ 8, "2020-02-16", "Democratic primaries", 14 ],
            [ 9, "2020-02-23", "Democratic primaries", 19 ],
            [ 10, "2020-03-01", "Democratic primaries", 100 ],
            [ 11, "2020-03-08", "Democratic primaries", 54 ],
            [ 12, "2020-03-15", "Democratic primaries", 19 ],
            [ 13, "2020-03-22", "Democratic primaries", 5 ],
            [ 14, "2020-03-29", "Democratic primaries", 3 ],
            [ 15, "2020-04-05", "Democratic primaries", 5 ],
            [ 16, "2020-04-12", "Democratic primaries", 1 ],
            [ 17, "2020-04-19", "Democratic primaries", 1 ],
            [ 18, "2020-04-26", "Democratic primaries", 1 ],
            [ 19, "2020-05-03", "Democratic primaries", 1 ],
            [ 20, "2020-05-10", "Democratic primaries", 1 ],
            [ 21, "2020-05-17", "Democratic primaries", 1 ],
            [ 22, "2020-05-24", "Democratic primaries", 1 ],
            [ 23, "2020-05-31", "Democratic primaries", 4 ],
            [ 24, "2020-06-07", "Democratic primaries", 2 ],
            [ 25, "2020-06-14", "Democratic primaries", 1 ],
            [ 26, "2020-06-21", "Democratic primaries", 4 ],
            [ 27, "2020-06-28", "Democratic primaries", 2 ],
            [ 28, "2020-07-05", "Democratic primaries", 1 ],
            [ 29, "2020-07-12", "Democratic primaries", 1 ],
            [ 30, "2020-07-19", "Democratic primaries", 1 ],
            [ 31, "2020-07-26", "Democratic primaries", 1 ],
            [ 32, "2020-08-02", "Democratic primaries", 2 ],
            [ 33, "2020-08-09", "Democratic primaries", 2 ],
            [ 34, "2020-08-16", "Democratic primaries", 2 ],
            [ 35, "2020-08-23", "Democratic primaries", 1 ],
            [ 36, "2020-08-30", "Democratic primaries", 1 ],
            [ 37, "2020-09-06", "Democratic primaries", 1 ],
            [ 38, "2020-09-13", "Democratic primaries", 1 ],
            [ 39, "2020-09-20", "Democratic primaries", 1 ],
            [ 40, "2020-09-27", "Democratic primaries", 1 ],
            [ 41, "2020-10-04", "Democratic primaries", 1 ],
            [ 42, "2020-10-11", "Democratic primaries", 1 ],
            [ 43, "2020-10-18", "Democratic primaries", 1 ],
            [ 44, "2020-10-25", "Democratic primaries", 1 ],
            [ 45, "2020-11-01", "Democratic primaries", 2 ],
            [ 46, "2020-11-08", "Democratic primaries", 1 ],
            [ 47, "2020-11-15", "Democratic primaries", 0.5 ],
            [ 48, "2020-11-22", "Democratic primaries", 0.5 ],
            [ 49, "2020-11-29", "Democratic primaries", 0.5 ],
            [ 50, "2020-12-06", "Democratic primaries", 0.5 ],
            [ 51, "2020-12-13", "Democratic primaries", 0.5 ],
            [ 52, "2020-12-20", "Democratic primaries", 0.5 ],
            [ 53, "2020-12-27", "Democratic primaries", 0.5 ],
            [ 1, "2019-12-29", "John Lewis", 22 ],
            [ 2, "2020-01-05", "John Lewis", 1 ],
            [ 3, "2020-01-12", "John Lewis", 1 ],
            [ 4, "2020-01-19", "John Lewis", 1 ],
            [ 5, "2020-01-26", "John Lewis", 1 ],
            [ 6, "2020-02-02", "John Lewis", 1 ],
            [ 7, "2020-02-09", "John Lewis", 1 ],
            [ 8, "2020-02-16", "John Lewis", 1 ],
            [ 9, "2020-02-23", "John Lewis", 2 ],
            [ 10, "2020-03-01", "John Lewis", 3 ],
            [ 11, "2020-03-08", "John Lewis", 1 ],
            [ 12, "2020-03-15", "John Lewis", 0.5 ],
            [ 13, "2020-03-22", "John Lewis", 0.5 ],
            [ 14, "2020-03-29", "John Lewis", 0.5 ],
            [ 15, "2020-04-05", "John Lewis", 1 ],
            [ 16, "2020-04-12", "John Lewis", 0.5 ],
            [ 17, "2020-04-19", "John Lewis", 0.5 ],
            [ 18, "2020-04-26", "John Lewis", 1 ],
            [ 19, "2020-05-03", "John Lewis", 1 ],
            [ 20, "2020-05-10", "John Lewis", 1 ],
            [ 21, "2020-05-17", "John Lewis", 0.5 ],
            [ 22, "2020-05-24", "John Lewis", 1 ],
            [ 23, "2020-05-31", "John Lewis", 3 ],
            [ 24, "2020-06-07", "John Lewis", 2 ],
            [ 25, "2020-06-14", "John Lewis", 1 ],
            [ 26, "2020-06-21", "John Lewis", 1 ],
            [ 27, "2020-06-28", "John Lewis", 1 ],
            [ 28, "2020-07-05", "John Lewis", 3 ],
            [ 29, "2020-07-12", "John Lewis", 55 ],
            [ 30, "2020-07-19", "John Lewis", 46 ],
            [ 31, "2020-07-26", "John Lewis", 100 ],
            [ 32, "2020-08-02", "John Lewis", 14 ],
            [ 33, "2020-08-09", "John Lewis", 4 ],
            [ 34, "2020-08-16", "John Lewis", 4 ],
            [ 35, "2020-08-23", "John Lewis", 3 ],
            [ 36, "2020-08-30", "John Lewis", 2 ],
            [ 37, "2020-09-06", "John Lewis", 2 ],
            [ 38, "2020-09-13", "John Lewis", 2 ],
            [ 39, "2020-09-20", "John Lewis", 3 ],
            [ 40, "2020-09-27", "John Lewis", 3 ],
            [ 41, "2020-10-04", "John Lewis", 1 ],
            [ 42, "2020-10-11", "John Lewis", 1 ],
            [ 43, "2020-10-18", "John Lewis", 1 ],
            [ 44, "2020-10-25", "John Lewis", 2 ],
            [ 45, "2020-11-01", "John Lewis", 4 ],
            [ 46, "2020-11-08", "John Lewis", 2 ],
            [ 47, "2020-11-15", "John Lewis", 1 ],
            [ 48, "2020-11-22", "John Lewis", 1 ],
            [ 49, "2020-11-29", "John Lewis", 1 ],
            [ 50, "2020-12-06", "John Lewis", 1 ],
            [ 51, "2020-12-13", "John Lewis", 0.5 ],
            [ 52, "2020-12-20", "John Lewis", 0.5 ],
            [ 53, "2020-12-27", "John Lewis", 0.5 ],
        ]; break;
        
        // Fisher's Iris data (https://en.wikipedia.org/wiki/Iris_flower_data_set).
        default: data = [
            [ "versicolor", 7, 3.2, 4.7, 1.4 ],
            [ "versicolor", 6.4, 3.2, 4.5, 1.5 ],
            [ "versicolor", 6.9, 3.1, 4.9, 1.5 ],
            [ "versicolor", 5.5, 2.3, 4, 1.3 ],
            [ "versicolor", 6.5, 2.8, 4.6, 1.5 ],
            [ "versicolor", 5.7, 2.8, 4.5, 1.3 ],
            [ "versicolor", 6.3, 3.3, 4.7, 1.6 ],
            [ "versicolor", 4.9, 2.4, 3.3, 1 ],
            [ "versicolor", 6.6, 2.9, 4.6, 1.3 ],
            [ "versicolor", 5.2, 2.7, 3.9, 1.4 ],
            [ "versicolor", 5, 2, 3.5, 1 ],
            [ "versicolor", 5.9, 3, 4.2, 1.5 ],
            [ "versicolor", 6, 2.2, 4, 1 ],
            [ "versicolor", 6.1, 2.9, 4.7, 1.4 ],
            [ "versicolor", 5.6, 2.9, 3.6, 1.3 ],
            [ "versicolor", 6.7, 3.1, 4.4, 1.4 ],
            [ "versicolor", 5.6, 3, 4.5, 1.5 ],
            [ "versicolor", 5.8, 2.7, 4.1, 1 ],
            [ "versicolor", 6.2, 2.2, 4.5, 1.5 ],
            [ "versicolor", 5.6, 2.5, 3.9, 1.1 ],
            [ "versicolor", 5.9, 3.2, 4.8, 1.8 ],
            [ "versicolor", 6.1, 2.8, 4, 1.3 ],
            [ "versicolor", 6.3, 2.5, 4.9, 1.5 ],
            [ "versicolor", 6.1, 2.8, 4.7, 1.2 ],
            [ "versicolor", 6.4, 2.9, 4.3, 1.3 ],
            [ "versicolor", 6.6, 3, 4.4, 1.4 ],
            [ "versicolor", 6.8, 2.8, 4.8, 1.4 ],
            [ "versicolor", 6.7, 3, 5, 1.7 ],
            [ "versicolor", 6, 2.9, 4.5, 1.5 ],
            [ "versicolor", 5.7, 2.6, 3.5, 1 ],
            [ "versicolor", 5.5, 2.4, 3.8, 1.1 ],
            [ "versicolor", 5.5, 2.4, 3.7, 1 ],
            [ "versicolor", 5.8, 2.7, 3.9, 1.2 ],
            [ "versicolor", 6, 2.7, 5.1, 1.6 ],
            [ "versicolor", 5.4, 3, 4.5, 1.5 ],
            [ "versicolor", 6, 3.4, 4.5, 1.6 ],
            [ "versicolor", 6.7, 3.1, 4.7, 1.5 ],
            [ "versicolor", 6.3, 2.3, 4.4, 1.3 ],
            [ "versicolor", 5.6, 3, 4.1, 1.3 ],
            [ "versicolor", 5.5, 2.5, 4, 1.3 ],
            [ "versicolor", 5.5, 2.6, 4.4, 1.2 ],
            [ "versicolor", 6.1, 3, 4.6, 1.4 ],
            [ "versicolor", 5.8, 2.6, 4, 1.2 ],
            [ "versicolor", 5, 2.3, 3.3, 1 ],
            [ "versicolor", 5.6, 2.7, 4.2, 1.3 ],
            [ "versicolor", 5.7, 3, 4.2, 1.2 ],
            [ "versicolor", 5.7, 2.9, 4.2, 1.3 ],
            [ "versicolor", 6.2, 2.9, 4.3, 1.3 ],
            [ "versicolor", 5.1, 2.5, 3, 1.1 ],
            [ "versicolor", 5.7, 2.8, 4.1, 1.3 ],
            [ "virginica", 6.3, 3.3, 6, 2.5 ],
            [ "virginica", 5.8, 2.7, 5.1, 1.9 ],
            [ "virginica", 7.1, 3, 5.9, 2.1 ],
            [ "virginica", 6.3, 2.9, 5.6, 1.8 ],
            [ "virginica", 6.5, 3, 5.8, 2.2 ],
            [ "virginica", 7.6, 3, 6.6, 2.1 ],
            [ "virginica", 4.9, 2.5, 4.5, 1.7 ],
            [ "virginica", 7.3, 2.9, 6.3, 1.8 ],
            [ "virginica", 6.7, 2.5, 5.8, 1.8 ],
            [ "virginica", 7.2, 3.6, 6.1, 2.5 ],
            [ "virginica", 6.5, 3.2, 5.1, 2 ],
            [ "virginica", 6.4, 2.7, 5.3, 1.9 ],
            [ "virginica", 6.8, 3, 5.5, 2.1 ],
            [ "virginica", 5.7, 2.5, 5, 2 ],
            [ "virginica", 5.8, 2.8, 5.1, 2.4 ],
            [ "virginica", 6.4, 3.2, 5.3, 2.3 ],
            [ "virginica", 6.5, 3, 5.5, 1.8 ],
            [ "virginica", 7.7, 3.8, 6.7, 2.2 ],
            [ "virginica", 7.7, 2.6, 6.9, 2.3 ],
            [ "virginica", 6, 2.2, 5, 1.5 ],
            [ "virginica", 6.9, 3.2, 5.7, 2.3 ],
            [ "virginica", 5.6, 2.8, 4.9, 2 ],
            [ "virginica", 7.7, 2.8, 6.7, 2 ],
            [ "virginica", 6.3, 2.7, 4.9, 1.8 ],
            [ "virginica", 6.7, 3.3, 5.7, 2.1 ],
            [ "virginica", 7.2, 3.2, 6, 1.8 ],
            [ "virginica", 6.2, 2.8, 4.8, 1.8 ],
            [ "virginica", 6.1, 3, 4.9, 1.8 ],
            [ "virginica", 6.4, 2.8, 5.6, 2.1 ],
            [ "virginica", 7.2, 3, 5.8, 1.6 ],
            [ "virginica", 7.4, 2.8, 6.1, 1.9 ],
            [ "virginica", 7.9, 3.8, 6.4, 2 ],
            [ "virginica", 6.4, 2.8, 5.6, 2.2 ],
            [ "virginica", 6.3, 2.8, 5.1, 1.5 ],
            [ "virginica", 6.1, 2.6, 5.6, 1.4 ],
            [ "virginica", 7.7, 3, 6.1, 2.3 ],
            [ "virginica", 6.3, 3.4, 5.6, 2.4 ],
            [ "virginica", 6.4, 3.1, 5.5, 1.8 ],
            [ "virginica", 6, 3, 4.8, 1.8 ],
            [ "virginica", 6.9, 3.1, 5.4, 2.1 ],
            [ "virginica", 6.7, 3.1, 5.6, 2.4 ],
            [ "virginica", 6.9, 3.1, 5.1, 2.3 ],
            [ "virginica", 5.8, 2.7, 5.1, 1.9 ],
            [ "virginica", 6.8, 3.2, 5.9, 2.3 ],
            [ "virginica", 6.7, 3.3, 5.7, 2.5 ],
            [ "virginica", 6.7, 3, 5.2, 2.3 ],
            [ "virginica", 6.3, 2.5, 5, 1.9 ],
            [ "virginica", 6.5, 3, 5.2, 2 ],
            [ "virginica", 6.2, 3.4, 5.4, 2.3 ],
            [ "virginica", 5.9, 3, 5.1, 1.8 ],
            [ "setosa", 5.1, 3.5, 1.4, 0.2 ],
            [ "setosa", 4.9, 3, 1.4, 0.2 ],
            [ "setosa", 4.7, 3.2, 1.3, 0.2 ],
            [ "setosa", 4.6, 3.1, 1.5, 0.2 ],
            [ "setosa", 5, 3.6, 1.4, 0.2 ],
            [ "setosa", 5.4, 3.9, 1.7, 0.4 ],
            [ "setosa", 4.6, 3.4, 1.4, 0.3 ],
            [ "setosa", 5, 3.4, 1.5, 0.2 ],
            [ "setosa", 4.4, 2.9, 1.4, 0.2 ],
            [ "setosa", 4.9, 3.1, 1.5, 0.1 ],
            [ "setosa", 5.4, 3.7, 1.5, 0.2 ],
            [ "setosa", 4.8, 3.4, 1.6, 0.2 ],
            [ "setosa", 4.8, 3, 1.4, 0.1 ],
            [ "setosa", 4.3, 3, 1.1, 0.1 ],
            [ "setosa", 5.8, 4, 1.2, 0.2 ],
            [ "setosa", 5.7, 4.4, 1.5, 0.4 ],
            [ "setosa", 5.4, 3.9, 1.3, 0.4 ],
            [ "setosa", 5.1, 3.5, 1.4, 0.3 ],
            [ "setosa", 5.7, 3.8, 1.7, 0.3 ],
            [ "setosa", 5.1, 3.8, 1.5, 0.3 ],
            [ "setosa", 5.4, 3.4, 1.7, 0.2 ],
            [ "setosa", 5.1, 3.7, 1.5, 0.4 ],
            [ "setosa", 4.6, 3.6, 1, 0.2 ],
            [ "setosa", 5.1, 3.3, 1.7, 0.5 ],
            [ "setosa", 4.8, 3.4, 1.9, 0.2 ],
            [ "setosa", 5, 3, 1.6, 0.2 ],
            [ "setosa", 5, 3.4, 1.6, 0.4 ],
            [ "setosa", 5.2, 3.5, 1.5, 0.2 ],
            [ "setosa", 5.2, 3.4, 1.4, 0.2 ],
            [ "setosa", 4.7, 3.2, 1.6, 0.2 ],
            [ "setosa", 4.8, 3.1, 1.6, 0.2 ],
            [ "setosa", 5.4, 3.4, 1.5, 0.4 ],
            [ "setosa", 5.2, 4.1, 1.5, 0.1 ],
            [ "setosa", 5.5, 4.2, 1.4, 0.2 ],
            [ "setosa", 4.9, 3.1, 1.5, 0.2 ],
            [ "setosa", 5, 3.2, 1.2, 0.2 ],
            [ "setosa", 5.5, 3.5, 1.3, 0.2 ],
            [ "setosa", 4.9, 3.6, 1.4, 0.1 ],
            [ "setosa", 4.4, 3, 1.3, 0.2 ],
            [ "setosa", 5.1, 3.4, 1.5, 0.2 ],
            [ "setosa", 5, 3.5, 1.3, 0.3 ],
            [ "setosa", 4.5, 2.3, 1.3, 0.3 ],
            [ "setosa", 4.4, 3.2, 1.3, 0.2 ],
            [ "setosa", 5, 3.5, 1.6, 0.6 ],
            [ "setosa", 5.1, 3.8, 1.9, 0.4 ],
            [ "setosa", 4.8, 3, 1.4, 0.3 ],
            [ "setosa", 5.1, 3.8, 1.6, 0.2 ],
            [ "setosa", 4.6, 3.2, 1.4, 0.2 ],
            [ "setosa", 5.3, 3.7, 1.5, 0.2 ],
            [ "setosa", 5, 3.3, 1.4, 0.2 ],
        ] ; break;
    }
    return data;
};

export default Data;
